import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/Layout';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';
import { del, get, post, put } from '../../controllers/apiController';
import * as XLSX from 'xlsx';
import { Select2, Select2WColor } from '../../components/Select2';
import $ from 'jquery';
import Swal from 'sweetalert2';
import ChatWidget from '../../components/ChatWidget';
import NumberInput from '../../components/NumberInput';
import { useSettings } from '../../context/SettingsContext';
import { useAuth } from '../../context/AuthContext';
import { formatCurrency } from '../../utils/format';
import { DEFAULT_AVATAR } from '../../utils/defaultAvatar';

const TemsilciRow = ({ formID, temsilciId, temsilciIsim, temsilciler, onSaved }) => {
    const [editing, setEditing] = useState(false);
    const [val, setVal] = useState(temsilciId || '');
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        setSaving(true);
        try {
            await put('forms/change-user', { formID: parseInt(formID), userID: val ? parseInt(val) : null });
            const found = temsilciler.find(t => String(t.value) === String(val));
            onSaved(val ? parseInt(val) : null, found?.label || '');
            setEditing(false);
            toast.success('Temsilci güncellendi');
        } catch { toast.error('Güncellenemedi'); }
        setSaving(false);
    };

    const displayName = temsilciIsim && temsilciIsim !== 'null null' ? temsilciIsim : null;

    return (
        <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
            <i className="feather-user text-muted me-3" style={{ width: '16px' }}></i>
            <div className="flex-grow-1">
                <div className="text-muted" style={{ fontSize: '11px' }}>Satış Temsilcisi</div>
                {editing ? (
                    <div style={{ display: 'flex', gap: '4px', marginTop: '2px' }}>
                        <select autoFocus value={val} onChange={e => setVal(e.target.value)}
                            style={{ flex: 1, padding: '3px 7px', borderRadius: '6px', border: '1px solid #e5e7eb', fontSize: '12px', outline: 'none', background: '#fff' }}>
                            <option value="">— Temsilci Seç —</option>
                            {temsilciler.map(t => (
                                <option key={t.value} value={t.value}>{t.label}</option>
                            ))}
                        </select>
                        <button type="button" onClick={handleSave} disabled={saving}
                            style={{ background: '#10b981', border: 'none', borderRadius: '6px', color: '#fff', padding: '2px 8px', cursor: 'pointer', fontSize: '12px' }}>
                            {saving ? <span className="spinner-border spinner-border-sm" style={{ width: '10px', height: '10px' }} /> : <i className="feather-check" />}
                        </button>
                        <button type="button" onClick={() => { setEditing(false); setVal(temsilciId || ''); }}
                            style={{ background: '#f3f4f6', border: 'none', borderRadius: '6px', color: '#6b7280', padding: '2px 6px', cursor: 'pointer', fontSize: '12px' }}>
                            <i className="feather-x" />
                        </button>
                    </div>
                ) : (
                    <div className="fw-semibold" style={{ fontSize: '13px' }}>
                        {displayName ? (
                            <span style={{ background: '#eff6ff', color: '#2563eb', padding: '2px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: 700 }}>
                                <i className="feather-user me-1" style={{ fontSize: '10px' }}></i>{displayName}
                            </span>
                        ) : <span className="text-muted">Atanmamış</span>}
                    </div>
                )}
            </div>
            {!editing && (
                <button className="btn btn-link text-primary p-0 ms-2" onClick={() => { setEditing(true); setVal(temsilciId || ''); }} style={{ fontSize: '13px' }}>
                    <i className="feather-edit-2"></i>
                </button>
            )}
        </div>
    );
};

// ── Aylık Teklif Tutarı satırı bileşeni ───────────────────────────────────────
const TeklifTutariRow = ({ formID, teklifTutari, onSaved }) => {
    const [editing, setEditing] = useState(false);
    const [val, setVal] = useState(teklifTutari ?? '');
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        if (val === '' || Number(val) < 0) {
            toast.error('Geçerli bir tutar giriniz');
            return;
        }
        setSaving(true);
        try {
            await put('forms/change-teklif-tutari', { formID: parseInt(formID), teklifTutari: parseFloat(val) });
            onSaved(parseFloat(val));
            setEditing(false);
            toast.success('Teklif tutarı güncellendi');
        } catch { toast.error('Güncellenemedi'); }
        setSaving(false);
    };

    return (
        <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
            <i className="feather-dollar-sign text-muted me-3" style={{ width: '16px' }}></i>
            <div className="flex-grow-1">
                <div className="text-muted" style={{ fontSize: '11px' }}>Aylık Teklif Tutarı</div>
                {editing ? (
                    <div style={{ display: 'flex', gap: '4px', marginTop: '2px' }}>
                        <input
                            type="number" min="0" step="0.01" autoFocus
                            style={{ flex: 1, padding: '3px 7px', borderRadius: '6px', border: '1px solid #e5e7eb', fontSize: '12px', outline: 'none' }}
                            value={val}
                            onChange={e => setVal(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') handleSave(); if (e.key === 'Escape') { setEditing(false); setVal(teklifTutari ?? ''); } }}
                            placeholder="ör: 35000"
                        />
                        <button type="button" onClick={handleSave} disabled={saving}
                            style={{ background: '#10b981', border: 'none', borderRadius: '6px', color: '#fff', padding: '2px 8px', cursor: 'pointer', fontSize: '12px' }}>
                            {saving ? <span className="spinner-border spinner-border-sm" style={{ width: '10px', height: '10px' }} /> : <i className="feather-check" />}
                        </button>
                        <button type="button" onClick={() => { setEditing(false); setVal(teklifTutari ?? ''); }}
                            style={{ background: '#f3f4f6', border: 'none', borderRadius: '6px', color: '#6b7280', padding: '2px 6px', cursor: 'pointer', fontSize: '12px' }}>
                            <i className="feather-x" />
                        </button>
                    </div>
                ) : (
                    <div className="fw-semibold" style={{ fontSize: '13px' }}>
                        {teklifTutari ? formatCurrency(teklifTutari) : <span className="text-muted">Belirtilmemiş</span>}
                    </div>
                )}
            </div>
            {!editing && (
                <button className="btn btn-link text-primary p-0 ms-2" onClick={() => { setEditing(true); setVal(teklifTutari ?? ''); }} style={{ fontSize: '13px' }}>
                    <i className="feather-edit-2"></i>
                </button>
            )}
        </div>
    );
};

const FormDetay = () => {
    const [searchParams] = useSearchParams();
    const { isFeatureEnabled, isModuleActive } = useSettings();
    const { user } = useAuth();
    const isAdmin = user?.Kullanici_Yetki == 0;

    // Pipeline aşamaları (ayarlardan yüklenir)
    const [pipelineStages, setPipelineStages] = useState([]);
    const [currentPipelineStage, setCurrentPipelineStage] = useState(null);
    const [currentPipelineAltAksiyon, setCurrentPipelineAltAksiyon] = useState(null);
    const [isPipelineChanging, setIsPipelineChanging] = useState(false);
    // Bekleyen aşama değişikliği (sub-aksiyon / kapanış sebebi için 2 adımlı akış)
    const [pendingAsamaId, setPendingAsamaId] = useState(null);
    const [pendingSubAction, setPendingSubAction] = useState('');
    const [closingReason, setClosingReason] = useState('');
    const [autoReminderDate, setAutoReminderDate] = useState(null);

    const [formData, setFormData] = useState({
        LeadInfo: {
            Adi_Soyadi: '',
            E_Posta: '',
            Telefon: '',
            Mesaj: '',
            UTM: '',
            Tarih: '',
            IP: '',
            Kaynak: '',
            Aciklama: '',
            Ziyaret_Tarihi: '', // yeni alan
            Gorusme_Sayisi: 0, // yeni alan
            Satis_Tarihi: ''   // yeni alan
        },
        Hatirlatma_Tarihi: null,
        Etiketler: [],
        Temsilci_Isim: '',
        Temsilci_Profil: null
    });

    const [isLoading, setIsLoading] = useState(true);
    const [changeCallCountLoading, setChangeCallCountLoading] = useState(false);

    const [notes, setNotesData] = useState([]);
    const [files, setFilesData] = useState([]);

    const [selectedNote, setSelectedNote] = useState(null);

    const [temsilciler, setTemsilciler] = useState([]);
    const [etiketler, setEtiketler] = useState([]);

    const [formID] = useState(searchParams.get("id"));

    const addNoteRef = useRef(null);
    const editAciklamaRef = useRef(null);
    const editReminderRef = useRef(null);
    const editTemsilciRef = useRef(null);
    const addEtiketRef = useRef(null);
    const viewNoteRef = useRef(null);

    const editNameSurnameRef = useRef(null);
    const editEmailRef = useRef(null);
    const editPhoneNumberRef = useRef(null);

    const temsilciSelectRef = useRef(null);
    const etiketSelectRef = useRef(null);

    const [newNameSurname, setNewNameSurname] = useState(null);
    const [newEmail, setNewEmail] = useState(null);
    const [newPhoneNumber, setNewPhoneNumber] = useState(null);

    const [yeniAciklama, setYeniAciklama] = useState('');
    const [reminderDate, setReminderDate] = useState('');

    const [smsMessage, setSmsMessage] = useState('');
    const [isSendingSms, setIsSendingSms] = useState(false);

    // VAPI
    const [vapiCalls, setVapiCalls] = useState([]);
    const [vapiCalling, setVapiCalling] = useState(false);
    const [vapiQueued, setVapiQueued] = useState(false);
    const [vapiCallsLoaded, setVapiCallsLoaded] = useState(false);
    const [vapiExpandedCall, setVapiExpandedCall] = useState(null);
    const [vapiRefreshing, setVapiRefreshing] = useState({});

    const [newEtiket, setNewEtiket] = useState(null);

    const [noteTitle, setNoteTitle] = useState('');
    const [noteDesc, setNoteDesc] = useState('');

    const chatRef = useRef();
    const uploadFileInput = useRef();

    const normalizePhone = (phone) => {
        if (!phone) return phone;
        let p = phone.replace(/\s+/g, '').replace(/[^0-9+]/g, '');
        if (p.startsWith('0')) p = '+90' + p.slice(1);
        else if (!p.startsWith('+')) p = '+90' + p;
        return p;
    };

    const formatToDateOnly = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formatToDateTimeLocal = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    useEffect(() => {
        const getFormData = async () => {
            try {
                const res = await get(`forms/${formID}`);
                if (res) {
                    setFormData(res);
                    setNotesData(res.Notlar);
                    setFilesData(res.Dosyalar);
                    setYeniAciklama(res.LeadInfo.Aciklama);
                    setReminderDate(formatToDateTimeLocal(res.Hatirlatma_Tarihi));
                    setVisitDate(res.LeadInfo.Ziyaret_Tarihi ? formatToDateTimeLocal(res.LeadInfo.Ziyaret_Tarihi) : '');
                    setMeetCount(res.LeadInfo.Gorusme_Sayisi || 0);
                    setSellDate(res.LeadInfo.Satis_Tarihi ? formatToDateTimeLocal(res.LeadInfo.Satis_Tarihi) : '');
                    setAramaTarihi(res.LeadInfo.Arama_Tarihi || null);
                    setUlasimDurumu(res.LeadInfo.Ulasim_Durumu !== undefined ? res.LeadInfo.Ulasim_Durumu : null);
                    setToplantıTalepTarihi(res.LeadInfo.Toplanti_Talep_Tarihi || null);
                    setToplantıTarihi(res.LeadInfo.Toplanti_Tarihi || null);
                    setCurrentPipelineStage(res.LeadInfo.Pipeline_Asama_ID || null);
                    setCurrentPipelineAltAksiyon(res.LeadInfo.Pipeline_Alt_Aksiyon || null);
                    setBeklenenKapanisTarihi(res.LeadInfo.Beklenen_Kapanis_Tarihi ? formatToDateOnly(res.LeadInfo.Beklenen_Kapanis_Tarihi) : '');
                    setSonrakiAksiyonTarihi(res.LeadInfo.Sonraki_Aksiyon_Tarihi ? formatToDateOnly(res.LeadInfo.Sonraki_Aksiyon_Tarihi) : '');

                    document.title = `Form - ${res.LeadInfo.Adi_Soyadi} | LEVELUP CRM`;
                } else {
                    document.title = "Bulunamadı | LEVELUP CRM";
                }
            } catch (error) {
                toast.error("Form bilgileri yüklenirken hata oluştu");
            }

        }

        const getTemsilcilerData = async () => {
            try {
                const res = await get("users/company-users");

                const temsilcilerMapped = res.map(temsilci => {
                    return {
                        value: temsilci.Kullanici_ID,
                        label: `${temsilci.Kullanici_Adi} ${temsilci.Kullanici_Soyadi}`
                    }
                });

                setTemsilciler(temsilcilerMapped);
            } catch (err) {
                toast.error("Temsilci verileri alınırken bir hata oluştu!");
            }
        }

        const getEtiketlerData = async () => {
            try {
                const res = await get("labels/");

                const etiketlerMapped = res.map(etiket => {
                    return {
                        value: etiket.Etiket_ID,
                        label: etiket.Etiket_Adi,
                        color: "#" + etiket.Etiket_Renk
                    }
                });

                setEtiketler(etiketlerMapped);
            } catch (err) {
                toast.error("Etiket verileri alınırken bir hata oluştu!");
            }
        }

        const getPipelineStages = async () => {
            try {
                const res = await get('settings/pipeline');
                setPipelineStages(res?.stages || []);
            } catch { /* pipeline yüklenemedi */ }
        };

        const getAllData = async () => {
            await Promise.all([getFormData(), getTemsilcilerData(), getEtiketlerData(), getPipelineStages()]);
            setIsLoading(false);
            // VAPI kuyruk durumunu kontrol et (arka planda)
            checkVapiQueue();
        }

        if (formID) {
            getAllData();
        }

    }, [formID]);

    useEffect(() => {
        // Modal açıldığında body'deki modal-open class'ını kaldır
        const removeModalOpenClass = () => {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0';
        };

        // Modal eventlerini dinle
        const addNoteModal = document.getElementById('addNote');
        const editAciklamaModal = document.getElementById('editAciklama');
        const editReminderModal = document.getElementById('editReminder');
        const editTemsilciModal = document.getElementById('editTemsilci');
        const addEtiketModal = document.getElementById('addEtiket');
        const viewNoteModal = document.getElementById('viewNote');

        const editNameSurnameModal = document.getElementById('editNameSurname');
        const editEmailModal = document.getElementById('editEmail');
        const editPhoneNumberModal = document.getElementById('editPhoneNumber');
        const editVisitDateModal = document.getElementById('editVisitDate');
        const editMeetCountModal = document.getElementById('editMeetCount');
        const editSellDateModal = document.getElementById('editSellDate');
        const editBeklenenKapanisTarihiModal = document.getElementById('editBeklenenKapanisTarihi');
        const editSonrakiAksiyonTarihiModal = document.getElementById('editSonrakiAksiyonTarihi');
        const kayipModalEl = document.getElementById('kayipModal');
        const sendSmsModalEl = document.getElementById('sendSmsModal');
        const editToplantıTarihiModalEl = document.getElementById('editToplantıTarihi');

        addNoteModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editAciklamaModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editTemsilciModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editReminderModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        addEtiketModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        viewNoteModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editNameSurnameModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editEmailModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editPhoneNumberModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editVisitDateModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editMeetCountModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editSellDateModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editBeklenenKapanisTarihiModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editSonrakiAksiyonTarihiModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        kayipModalEl?.addEventListener('shown.bs.modal', removeModalOpenClass);
        sendSmsModalEl?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editToplantıTarihiModalEl?.addEventListener('shown.bs.modal', removeModalOpenClass);

        return () => {
            addNoteModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editAciklamaModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editReminderModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editTemsilciModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            addEtiketModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            viewNoteModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editNameSurnameModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editEmailModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editPhoneNumberModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editVisitDateModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editMeetCountModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editSellDateModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editBeklenenKapanisTarihiModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editSonrakiAksiyonTarihiModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            kayipModalEl?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            sendSmsModalEl?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editToplantıTarihiModalEl?.removeEventListener('shown.bs.modal', removeModalOpenClass);
        };
    }, []);

    const createNote = async (useModal = true) => {
        if (noteTitle == "" || noteDesc == "") {
            toast.error("Tüm alanlar doldurulmalıdır!");
            return;
        }

        try {
            const response = await post('forms/note', {
                formID: formID,
                title: noteTitle,
                desc: noteDesc
            });

            setNotesData(prev => [...prev, response]);

            if (useModal) {
                addNoteRef.current.querySelector('[data-bs-dismiss="modal"]').click();
            }

            setNoteTitle("");
            setNoteDesc("");

            toast.success("Not başarıyla oluşturuldu.");
        } catch (err) {
            console.error(err);
            toast.error(err.response.data.message || "Bilinmeyen bir hata oluştu!");
        }
    }

    const deleteNote = async (noteID) => {
        console.log(noteID);
        Swal.fire({
            title: 'Notu silmek istediğinize emin misiniz?',
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await del(`forms/note/${noteID}`);

                    setNotesData(notes.filter((not) => not.Not_ID != noteID));

                    toast.success("Not başarıyla silindi.");
                } catch (err) {
                    toast.error(err.response.data.message);
                }
            }
        });
    }

    const viewNote = async (noteID) => {
        const noteData = notes.find((not) => not.Not_ID == noteID);

        setSelectedNote(noteData);
    }

    useEffect(() => {
        if (selectedNote != null) {
            const viewNoteDesc = document.getElementById("viewNoteDesc");

            viewNoteDesc.style.height = 'auto';
            viewNoteDesc.style.height = viewNoteDesc.scrollHeight + 'px';
        }
    }, [selectedNote]);

    const handlePrint = () => {
        const printContent = `
            FORM BİLGİLERİ
            
            Kişisel Bilgiler:
            
            Adı Soyadı: ${formData.LeadInfo.Adi_Soyadi}
            E-Posta: ${formData.LeadInfo.E_Posta}
            Telefon: ${formData.LeadInfo.Telefon}
            Mesaj: ${formData.LeadInfo.Mesaj}
            
            Form Detayları:
            
            UTM: ${formData.LeadInfo.UTM || 'Belirtilmemiş'}
            Tarih: ${new Date(formData.LeadInfo.Tarih).toLocaleString('tr-TR')}
            Kaynak: ${formData.LeadInfo.Kaynak}
            IP: ${formData.LeadInfo.IP || 'Belirtilmemiş'}
            
            Diğer Bilgiler:
            
            Temsilci: ${formData.Temsilci_Isim}
            Etiketler: ${formData.Etiketler.map(etiket => etiket.Etiket_Adi).join(', ')}
            Açıklama: ${formData.LeadInfo.Aciklama || 'Belirtilmemiş'}
        `;

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Form Detayı - ${formData.LeadInfo.Adi_Soyadi}</title>
                    <style>
                        body { font-family: Arial, sans-serif; line-height: 1.6; padding: 20px; }
                        pre { white-space: pre-wrap; }
                    </style>
                </head>
                <body>
                    <pre>${printContent}</pre>
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.print();
    };

    const handleExport = () => {
        const exportData = [{
            'Adı Soyadı': formData.LeadInfo.Adi_Soyadi,
            'E-Posta': formData.LeadInfo.E_Posta,
            'Telefon': formData.LeadInfo.Telefon,
            'Mesaj': formData.LeadInfo.Mesaj,
            'UTM': formData.LeadInfo.UTM || 'Belirtilmemiş',
            'Tarih': new Date(formData.LeadInfo.Tarih).toLocaleString('tr-TR'),
            'Kaynak': formData.LeadInfo.Kaynak,
            'IP': formData.LeadInfo.IP || 'Belirtilmemiş',
            'Temsilci': formData.Temsilci_Isim == "null null" ? "" : formData.Temsilci_Isim,
            'Etiketler': formData.Etiketler.map(etiket => etiket.Etiket_Adi).join(', '),
            'Açıklama': formData.LeadInfo.Aciklama || 'Belirtilmemiş'
        }];

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Form Detay");
        XLSX.writeFile(wb, `Form_${formData.LeadInfo.Adi_Soyadi}_${new Date().toLocaleDateString()}.xlsx`);
    };

    const loadVapiCalls = async () => {
        try {
            const res = await get(`vapi/calls/${formID}`);
            setVapiCalls(res?.calls || []);
            setVapiCallsLoaded(true);
        } catch { /* sessizce */ }
    };

    const checkVapiQueue = async () => {
        try {
            const res = await get(`vapi/queue/${formID}`);
            setVapiQueued(res?.queued || false);
        } catch { /* sessizce */ }
    };

    const handleVapiCall = async () => {
        setVapiCalling(true);
        try {
            const res = await post('vapi/call', { formId: parseInt(formID, 10) });
            toast.success(
                `Arama başlatıldı → ${res.formattedPhone}` +
                (res.callStatus ? ` (${res.callStatus})` : '') +
                `\nCall ID: ${res.callId}`,
                { autoClose: 8000 }
            );
            // Hemen ve 5s sonra tekrar yükle
            loadVapiCalls();
            setTimeout(() => loadVapiCalls(), 5000);
        } catch (e) {
            const detail = e?.response?.data?.message || e?.response?.data?.error || 'Arama başlatılamadı';
            toast.error(detail, { autoClose: 10000 });
        }
        setVapiCalling(false);
    };

    const handleVapiQueueCancel = async () => {
        try {
            await del(`vapi/queue/${formID}`);
            setVapiQueued(false);
            toast.success('Otomatik arama iptal edildi');
        } catch {
            toast.error('İptal başarısız');
        }
    };

    const handleVapiRefresh = async (aramaId) => {
        setVapiRefreshing(prev => ({ ...prev, [aramaId]: true }));
        try {
            const res = await post(`vapi/refresh/${aramaId}`, {});
            if (res.updated) {
                setVapiCalls(prev => prev.map(c =>
                    c.Arama_ID === aramaId
                        ? { ...c, Kayit_URL: res.recordingUrl || c.Kayit_URL, Transcript: res.transcript || c.Transcript, Sure_Saniye: res.durationSeconds || c.Sure_Saniye }
                        : c
                ));
                toast.success('Kayıt güncellendi');
            } else {
                toast.info('Kayıt henüz hazır değil, birkaç dakika sonra tekrar deneyin');
            }
        } catch {
            toast.error('Güncelleme başarısız');
        }
        setVapiRefreshing(prev => ({ ...prev, [aramaId]: false }));
    };

    const handleSendSms = async () => {
        if (!smsMessage.trim()) {
            toast.error('Mesaj boş olamaz!');
            return;
        }
        setIsSendingSms(true);
        try {
            await post('sms/send', {
                phone: formData.LeadInfo.Telefon,
                message: smsMessage.trim()
            });
            toast.success('SMS başarıyla gönderildi!');
            setSmsMessage('');
            document.getElementById('sendSmsModal')?.querySelector('[data-bs-dismiss="modal"]')?.click();
        } catch (err) {
            toast.error(err?.response?.data?.message || 'SMS gönderilemedi!');
        }
        setIsSendingSms(false);
    };

    const handleReminderUpdate = async () => {
        try {
            await put(`forms/change-reminder`, {
                formID: formID,
                reminderDate: reminderDate
            });

            setFormData(prev => ({
                ...prev,
                Hatirlatma_Tarihi: reminderDate
            }));

            toast.success("Hatırlatma tarihi başarıyla güncellendi");

            editReminderRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Hatırlatma tarihi güncellenirken hata oluştu");
        }
    };

    const deleteReminder = async () => {
        try {
            await put(`forms/change-reminder`, {
                formID: formID
            });

            setFormData(prev => ({
                ...prev,
                Hatirlatma_Tarihi: null
            }));
            toast.success("Hatırlatma tarihi başarıyla kaldırıldı");

            editReminderRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Hatırlatma tarihi kaldırılırken hata oluştu");
        }
    }

    const handleAciklamaUpdate = async () => {
        try {
            await put(`forms/change-description`, {
                formID: formID,
                description: yeniAciklama.trim()
            });

            setFormData(prev => ({
                ...prev,
                LeadInfo: {
                    ...prev.LeadInfo,
                    Aciklama: yeniAciklama.trim()
                }
            }));
            toast.success("Açıklama başarıyla güncellendi");

            editAciklamaRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Açıklama güncellenirken hata oluştu");
        }
    };

    const addEtiket = async (type) => {
        try {
            const labelData = await put(`forms/add-label/${type}`, {
                formID: formID,
                labelID: newEtiket.value
            });

            setFormData(prevFormData => ({
                ...prevFormData,
                Etiketler: [...prevFormData.Etiketler, {
                    Etiket_ID: newEtiket.value,
                    Etiket_Adi: labelData.Etiket_Adi,
                    Etiket_Renk: labelData.Etiket_Renk,
                    Etiket_Yazi_Renk: labelData.Etiket_Yazi_Renk
                }]
            }));

            addEtiketRef.current.querySelector('[data-bs-dismiss="modal"]').click();

            toast.success("Etiket başarıyla eklendi.");
        } catch (error) {
            console.error(error);
            toast.error(error.response.data.message || "Etiket eklenirken bir hata oluştu!");
        }
    }

    const deleteEtiket = async (labelId, type) => {
        Swal.fire({
            title: 'Etiketi silmek istediğinize emin misiniz?',
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await del(`forms/delete-label/${type}`, {
                        formID: formID,
                        labelID: parseInt(labelId)
                    });

                    setFormData({
                        ...formData,
                        Etiketler: formData.Etiketler.filter((etiket) => etiket.Etiket_ID != labelId)
                    });

                    toast.success("Etiket başarıyla silindi.");
                } catch (err) {
                    toast.error(err.response.data.message || "Etiket silinirken bir hata oluştu!");
                }
            }
        });
    }

    const handleNameSurnameUpdate = async () => {
        try {
            if (newNameSurname != null && newNameSurname.trim() != "") {
                await put(`forms/edit/${formID}/nameSurname`, {
                    nameSurname: newNameSurname.trim()
                });

                setFormData(prev => ({
                    ...prev,
                    LeadInfo: {
                        ...prev.LeadInfo,
                        Adi_Soyadi: newNameSurname.trim()
                    }
                }));
                toast.success("İsim soyisim güncellendi");

                editNameSurnameRef.current.querySelector('[data-bs-dismiss="modal"]').click();
            } else {
                toast.error("İsim soyisim boş olamaz!");
            }
        } catch (error) {
            toast.error("İsim soyisim güncellenirken hata oluştu");
        }
    };

    const handleEmailUpdate = async () => {
        try {
            if (newEmail != null && newEmail.trim() != "") {
                await put(`forms/edit/${formID}/email`, {
                    email: newEmail.trim()
                });

                setFormData(prev => ({
                    ...prev,
                    LeadInfo: {
                        ...prev.LeadInfo,
                        E_Posta: newEmail.trim()
                    }
                }));
                toast.success("E-Posta adresi güncellendi");

                editEmailRef.current.querySelector('[data-bs-dismiss="modal"]').click();
            } else {
                toast.error("E-Posta adresi boş olamaz!");
            }
        } catch (error) {
            toast.error("E-Posta adresi güncellenirken hata oluştu");
        }
    };

    const handlePhoneNumberUpdate = async () => {
        try {
            if (newPhoneNumber != null && newPhoneNumber.trim() != "") {
                await put(`forms/edit/${formID}/phoneNumber`, {
                    phoneNumber: newPhoneNumber.trim()
                });

                setFormData(prev => ({
                    ...prev,
                    LeadInfo: {
                        ...prev.LeadInfo,
                        Telefon: newPhoneNumber.trim()
                    }
                }));
                toast.success("Telefon numarası güncellendi");

                editPhoneNumberRef.current.querySelector('[data-bs-dismiss="modal"]').click();
            } else {
                toast.error("Telefon numarası boş olamaz!");
            }
        } catch (error) {
            toast.error("Telefon numarası güncellenirken hata oluştu");
        }
    };

    const changeCallCount = async (val) => {
        try {
            setChangeCallCountLoading(true);
            await put(`forms/change-call-count`, {
                formID,
                callCount: val
            });

            setFormData(prev => ({
                ...prev,
                LeadInfo: {
                    ...prev.LeadInfo,
                    Arama_Sayisi: val
                }
            }));
            toast.success("Arama sayısı başarıyla güncellendi!");

            setChangeCallCountLoading(false);
        } catch (error) {
            toast.error("Arama sayısı güncellenirken hata oluştu");
        }
    };

    const uploadFile = async (e) => {
        const file = e.target.files[0];

        try {
            const data = new FormData();
            data.append("file", file);

            const response = await post(`forms/upload-file/${formID}/${formData.LeadInfo.Adi_Soyadi}`, data);

            setFilesData(prevFiles => (
                [
                    response.data,
                    ...prevFiles
                ]
            ));

            toast.success("Dosya başarıyla yüklendi!");
        } catch (error) {
            toast.error("Dosya yüklenirken hata oluştu");
        }
    }

    const deleteFile = async (fileID) => {
        Swal.fire({
            title: 'Dosyayı silmek istediğinize emin misiniz?',
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await del(`forms/delete-file/${formID}/${fileID}`);

                    setFilesData(files.filter((file) => file.Dosya_ID != fileID));

                    toast.success("Dosya başarıyla silindi.");
                } catch (err) {
                    toast.error(err.response.data.message);
                }
            }
        });
    }

    const showFullText = async (fullText) => {
        Swal.fire({
            title: 'Mesaj',
            html: `<p class="text-justify lh-sm" style="font-size: 16px; color: #555;">${fullText}</p>`,
            icon: 'info',
            showConfirmButton: true,
            confirmButtonText: 'Tamam',
            confirmButtonColor: '#007bff', // Bootstrap mavi buton
            background: '#ffffff', // Beyaz arka plan
            showCancelButton: false,
            customClass: {
                title: 'text-center',
                popup: 'rounded-3 shadow-lg',
                content: 'text-muted',
                confirmButton: 'btn btn-primary btn-lg'
            },
            padding: '1.5em',
            backdrop: true,
            position: 'center',
            timer: 0
        });
    };


    const analyzeAI = async (message) => {
        try {
            const postData = formData.LeadInfo;

            postData.Etiketler = formData.Etiketler.map(etiket => etiket.Etiket_Adi).join(', ');

            const response = await post(`ai/lead-analysis`, postData);

            chatRef.current.addAIResponse(response.analysis.replace(/\d+\.\s/g, match => match.trim()));
        } catch (error) {
            chatRef.current.addAIResponse(error?.response?.data?.message || "Yapay zeka analizi sırasında hata oluştu!");
            toast.error(error?.response?.data?.message || "Yapay zeka analizi sırasında hata oluştu!");
        }
    };

    const [contracts, setContracts] = useState([]);
    const [kayipNeden, setKayipNeden] = useState('');
    const kayipModalRef = useRef(null);
    const [isSavingTeklif, setIsSavingTeklif] = useState(false);

    useEffect(() => {
        if (formID) {
            get(`contracts/?formId=${formID}`).then(res => setContracts(res || [])).catch(() => {});
        }
    }, [formID]);

    const handleKayipIsaretle = async () => {
        try {
            await put('forms/change-kayip', {
                formID,
                kayip: true,
                kayipNeden
            });
            setFormData(prev => ({
                ...prev,
                LeadInfo: { ...prev.LeadInfo, Kayip: 1, Kayip_Neden: kayipNeden }
            }));
            kayipModalRef.current?.querySelector('[data-bs-dismiss="modal"]')?.click();
            setKayipNeden('');
            toast.success('Lead kayıp olarak işaretlendi.');
        } catch (err) {
            toast.error('İşlem sırasında hata oluştu!');
        }
    };

    const handleKayipGeriAl = async () => {
        Swal.fire({
            title: 'Kayıp durumunu geri almak istiyor musunuz?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Evet, geri al',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await put('forms/change-kayip', { formID, kayip: false });
                    setFormData(prev => ({
                        ...prev,
                        LeadInfo: { ...prev.LeadInfo, Kayip: 0, Kayip_Neden: null }
                    }));
                    toast.success('Kayıp durumu kaldırıldı.');
                } catch (err) {
                    toast.error('İşlem sırasında hata oluştu!');
                }
            }
        });
    };

    const handleTeklifVer = async () => {
        setIsSavingTeklif(true);
        try {
            await put('forms/change-teklif-date', { formID, teklifDate: new Date() });
            setFormData(prev => ({
                ...prev,
                LeadInfo: { ...prev.LeadInfo, Teklif_Tarihi: new Date().toISOString() }
            }));
            toast.success('Teklif tarihi kaydedildi!');
        } catch (err) {
            toast.error('Hata oluştu!');
        }
        setIsSavingTeklif(false);
    };

    const deleteContract = async (contractId) => {
        Swal.fire({
            title: 'Sözleşmeyi silmek istediğinize emin misiniz?',
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await del(`contracts/${contractId}`);
                    setContracts(contracts.filter(c => c.Sozlesme_ID !== contractId));
                    toast.success('Sözleşme silindi.');
                } catch (err) {
                    toast.error('Sözleşme silinirken hata oluştu!');
                }
            }
        });
    };

    const [visitDate, setVisitDate] = useState('');
    const [meetCount, setMeetCount] = useState(0);
    const [sellDate, setSellDate] = useState('');
    const editVisitDateRef = useRef(null);
    const editMeetCountRef = useRef(null);
    const editSellDateRef = useRef(null);

    // Fırsat alanları
    const [beklenenKapanisTarihi, setBeklenenKapanisTarihi] = useState('');
    const [sonrakiAksiyonTarihi, setSonrakiAksiyonTarihi] = useState('');
    const editBeklenenKapanisTarihiRef = useRef(null);
    const editSonrakiAksiyonTarihiRef = useRef(null);

    // Yeni pipeline alanları
    const [aramaTarihi, setAramaTarihi] = useState(null);
    const [ulasimDurumu, setUlasimDurumu] = useState(null);
    const [toplantıTalepTarihi, setToplantıTalepTarihi] = useState(null);
    const [toplantıTarihi, setToplantıTarihi] = useState(null);
    const [toplantıTarihiInput, setToplantıTarihiInput] = useState('');
    const [isPipelineLoading, setIsPipelineLoading] = useState(false);
    const editToplantıTarihiRef = useRef(null);

    const handleVisitDateUpdate = async () => {
        try {
            await put(`forms/change-visit-date`, {
                formID: formID,
                visitDate: visitDate
            });
            setFormData(prev => ({
                ...prev,
                LeadInfo: {
                    ...prev.LeadInfo,
                    Ziyaret_Tarihi: visitDate
                }
            }));
            toast.success("Tel/Mail görüşme zamanı başarıyla güncellendi");
            editVisitDateRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Tel/Mail görüşme zamanı güncellenirken hata oluştu");
        }
    };
    const handleMeetCountUpdate = async () => {
        try {
            await put(`forms/change-meet-count`, {
                formID: formID,
                meetCount: meetCount
            });
            setFormData(prev => ({
                ...prev,
                LeadInfo: {
                    ...prev.LeadInfo,
                    Gorusme_Sayisi: meetCount
                }
            }));
            toast.success("Görüşme sayısı başarıyla güncellendi");
            editMeetCountRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Görüşme sayısı güncellenirken hata oluştu");
        }
    };
    const handleSellDateUpdate = async () => {
        try {
            await put(`forms/change-sell-date`, {
                formID: formID,
                sellDate: sellDate
            });
            setFormData(prev => ({
                ...prev,
                LeadInfo: {
                    ...prev.LeadInfo,
                    Satis_Tarihi: sellDate
                }
            }));
            toast.success("Satış tarihi başarıyla güncellendi");
            editSellDateRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Satış tarihi güncellenirken hata oluştu");
        }
    };

    const handleBeklenenKapanisTarihiUpdate = async () => {
        const todayStr = formatToDateOnly(new Date());
        if (!beklenenKapanisTarihi || beklenenKapanisTarihi < todayStr) {
            toast.error('Beklenen kapanış tarihi geçmişte olamaz');
            return;
        }
        try {
            await put('forms/change-beklenen-kapanis-tarihi', {
                formID: formID,
                beklenenKapanisTarihi: beklenenKapanisTarihi
            });
            setFormData(prev => ({
                ...prev,
                LeadInfo: {
                    ...prev.LeadInfo,
                    Beklenen_Kapanis_Tarihi: beklenenKapanisTarihi
                }
            }));
            toast.success("Beklenen kapanış tarihi başarıyla güncellendi");
            editBeklenenKapanisTarihiRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error(error?.response?.data?.message || "Beklenen kapanış tarihi güncellenirken hata oluştu");
        }
    };

    const handleSonrakiAksiyonTarihiUpdate = async () => {
        const todayStr = formatToDateOnly(new Date());
        if (!sonrakiAksiyonTarihi || sonrakiAksiyonTarihi < todayStr) {
            toast.error('Sonraki aksiyon tarihi geçmişte olamaz');
            return;
        }
        try {
            await put('forms/change-sonraki-aksiyon-tarihi', {
                formID: formID,
                sonrakiAksiyonTarihi: sonrakiAksiyonTarihi
            });
            setFormData(prev => ({
                ...prev,
                LeadInfo: {
                    ...prev.LeadInfo,
                    Sonraki_Aksiyon_Tarihi: sonrakiAksiyonTarihi
                }
            }));
            toast.success("Sonraki aksiyon tarihi başarıyla güncellendi");
            editSonrakiAksiyonTarihiRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error(error?.response?.data?.message || "Sonraki aksiyon tarihi güncellenirken hata oluştu");
        }
    };

    const handleVisitDateRemove = async () => {
        try {
            await put(`forms/change-visit-date`, {
                formID: formID,
                visitDate: null
            });
            setFormData(prev => ({
                ...prev,
                LeadInfo: {
                    ...prev.LeadInfo,
                    Ziyaret_Tarihi: ''
                }
            }));
            setVisitDate('');
            toast.success("Tel/Mail görüşme zamanı kaldırıldı");
            editVisitDateRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Ziyaret tarihi kaldırılırken hata oluştu");
        }
    };
    const handleSellDateRemove = async () => {
        try {
            await put(`forms/change-sell-date`, {
                formID: formID,
                sellDate: null
            });
            setFormData(prev => ({
                ...prev,
                LeadInfo: {
                    ...prev.LeadInfo,
                    Satis_Tarihi: ''
                }
            }));
            setSellDate('');
            toast.success("Satış tarihi kaldırıldı");
            editSellDateRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Satış tarihi kaldırılırken hata oluştu");
        }
    };

    const handleArandiIşaretle = async () => {
        setIsPipelineLoading(true);
        try {
            const now = new Date().toISOString();
            await put('forms/change-call-status', { formID: parseInt(formID), callDate: now });
            setAramaTarihi(now);
            setUlasimDurumu(null);
            setFormData(prev => ({
                ...prev,
                LeadInfo: { ...prev.LeadInfo, Arama_Tarihi: now, Ulasim_Durumu: null }
            }));
            toast.success('Arama kaydedildi!');
        } catch (err) {
            toast.error('Hata oluştu!');
        }
        setIsPipelineLoading(false);
    };

    const handleUlasimGuncelle = async (durum) => {
        setIsPipelineLoading(true);
        try {
            await put('forms/change-call-status', { formID: parseInt(formID), callDate: aramaTarihi, ulasimDurumu: durum });
            setUlasimDurumu(durum);
            setFormData(prev => ({
                ...prev,
                LeadInfo: { ...prev.LeadInfo, Ulasim_Durumu: durum }
            }));
            toast.success(durum === 1 ? 'Ulaşıldı olarak işaretlendi!' : 'Ulaşılamadı olarak işaretlendi!');
        } catch (err) {
            toast.error('Hata oluştu!');
        }
        setIsPipelineLoading(false);
    };

    const handleToplantıTalepEt = async () => {
        setIsPipelineLoading(true);
        try {
            const now = new Date().toISOString();
            await put('forms/change-meeting-request', { formID: parseInt(formID), meetingRequestDate: now });
            setToplantıTalepTarihi(now);
            setFormData(prev => ({
                ...prev,
                LeadInfo: { ...prev.LeadInfo, Toplanti_Talep_Tarihi: now }
            }));
            toast.success('Toplantı talep edildi olarak işaretlendi!');
        } catch (err) {
            toast.error('Hata oluştu!');
        }
        setIsPipelineLoading(false);
    };

    const handleToplantıYapıldıKaydet = async () => {
        setIsPipelineLoading(true);
        try {
            const date = toplantıTarihiInput || new Date().toISOString();
            await put('forms/change-meeting-date', { formID: parseInt(formID), meetingDate: date });
            setToplantıTarihi(date);
            setFormData(prev => ({
                ...prev,
                LeadInfo: { ...prev.LeadInfo, Toplanti_Tarihi: date }
            }));
            toast.success('Toplantı tarihi kaydedildi!');
            editToplantıTarihiRef.current?.querySelector('[data-bs-dismiss="modal"]')?.click();
        } catch (err) {
            toast.error('Hata oluştu!');
        }
        setIsPipelineLoading(false);
    };

    // Adım 1: Aşama seç — sub-aksiyon/kapanış sebebi varsa beklet, yoksa direkt uygula
    const handleSelectPipelineStage = (asamaId) => {
        if (isPipelineChanging) return;
        if (Number(currentPipelineStage) === Number(asamaId) && !pendingAsamaId) {
            // Aynı aşamaya tıklama → kaldır
            applyPipelineChange(null, null, null);
            return;
        }
        const stage = pipelineStages.find(s => Number(s.Asama_ID) === Number(asamaId));
        const hasAlt = (() => { try { return stage?.Alt_Aksiyonlar ? JSON.parse(stage.Alt_Aksiyonlar).length > 0 : false; } catch { return false; } })();
        const isKaybedildi = stage?.Tur === 'kaybedildi';
        if (hasAlt || isKaybedildi) {
            // 2 adımlı: önce seçenek/sebep iste
            setPendingAsamaId(asamaId);
            setPendingSubAction('');
            setClosingReason('');
        } else {
            applyPipelineChange(asamaId, null, null);
        }
    };

    // Adım 2: Onaylama (sub-aksiyon veya kapanış sebebiyle birlikte gönder)
    const handleConfirmPipelineChange = () => {
        const stage = pipelineStages.find(s => Number(s.Asama_ID) === Number(pendingAsamaId));
        const isKaybedildi = stage?.Tur === 'kaybedildi';
        if (isKaybedildi && !closingReason.trim()) {
            toast.warning('Lütfen kapanış sebebini girin');
            return;
        }
        applyPipelineChange(pendingAsamaId, pendingSubAction || null, isKaybedildi ? closingReason.trim() : null);
    };

    const handleCancelPipelineChange = () => {
        setPendingAsamaId(null);
        setPendingSubAction('');
        setClosingReason('');
    };

    const applyPipelineChange = async (asamaId, altAksiyon, kapanisSebebi) => {
        setIsPipelineChanging(true);
        setPendingAsamaId(null);
        setPendingSubAction('');
        setClosingReason('');
        try {
            const res = await put('forms/change-pipeline-stage', {
                formID: parseInt(formID),
                asamaId: asamaId || null,
                altAksiyon: altAksiyon || null,
                kapanisSebebi: kapanisSebebi || null
            });
            setCurrentPipelineStage(asamaId || null);
            setCurrentPipelineAltAksiyon(altAksiyon || null);
            setFormData(prev => ({
                ...prev,
                LeadInfo: { ...prev.LeadInfo, Pipeline_Asama_ID: asamaId || null, Pipeline_Alt_Aksiyon: altAksiyon || null }
            }));
            if (res?.reminderSet) {
                const stage = pipelineStages.find(s => s.Asama_ID === asamaId);
                toast.success(`Pipeline: ${stage?.Ad} — ${stage?.Hatirlatma_Gun} iş günü sonraya hatırlatma oluşturuldu`);
                setAutoReminderDate(stage?.Hatirlatma_Gun);
            } else {
                const stageName = pipelineStages.find(s => s.Asama_ID === asamaId)?.Ad;
                toast.success(asamaId ? `Pipeline: ${stageName}` : 'Pipeline aşaması kaldırıldı');
                setAutoReminderDate(null);
            }
        } catch (err) {
            const msg = err?.response?.data?.message || '';
            if (msg.includes('Migration') || msg.includes('migration')) {
                toast.error('Veritabanı güncellemesi gerekiyor! pipeline_stage_migration.sql dosyasını çalıştırın.', { autoClose: 8000 });
            } else {
                toast.error('Pipeline aşaması güncellenemedi!');
            }
        }
        setIsPipelineChanging(false);
    };

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">

                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./dashboard">Anasayfa</a></li>
                                <li className="breadcrumb-item"><a href="./forms">Formlar</a></li>
                                <li className="breadcrumb-item">Detay</li>
                            </ul>
                        </div>
                        <div className="page-header-right ms-auto">
                            <div className="page-header-right-items">
                                <div className="d-flex d-md-none">
                                    <a href="javascript:void(0)" className="page-header-right-close-toggle">
                                        <i className="feather-arrow-left me-2"></i>
                                        <span>Geri</span>
                                    </a>
                                </div>
                                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                                    {!isLoading && (
                                        formData.LeadInfo.Kayip ? (
                                            <button onClick={handleKayipGeriAl} className="btn btn-outline-danger">
                                                <i className="feather-x-circle me-1"></i>Satışa Dönmedi Geri Al
                                            </button>
                                        ) : (
                                            <button className="btn btn-danger" data-bs-toggle="modal" data-bs-target="#kayipModal">
                                                <i className="feather-alert-triangle me-1"></i>Satışa Dönmedi İşaretle
                                            </button>
                                        )
                                    )}
                                    <a href="javascript:void(0);"
                                        onClick={handlePrint}
                                        className="btn btn-icon btn-light-brand">
                                        <i className="feather-printer"></i>
                                    </a>
                                    <a href="javascript:void(0);"
                                        onClick={handleExport}
                                        className="btn btn-icon btn-light-brand">
                                        <i className="feather-download"></i>
                                    </a>
                                </div>
                            </div>
                            <div className="d-md-none d-flex align-items-center">
                                <a href="javascript:void(0)" className="page-header-right-open-toggle">
                                    <i className="feather-align-right fs-20"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white py-3 border-bottom rounded-0 p-md-0 mb-0">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="nav-tabs-wrapper page-content-left-sidebar-wrapper">
                                <ul className="nav nav-tabs nav-tabs-custom-style" id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#infoTab">Bilgiler</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" data-bs-toggle="tab" data-bs-target="#notesTab">Notlar</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" data-bs-toggle="tab" data-bs-target="#filesTab">Dosyalar</button>
                                    </li>
                                    {isFeatureEnabled('vapi_tab') && isModuleActive('vapi') && (
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" data-bs-toggle="tab" data-bs-target="#vapiTab"
                                                onClick={() => { if (!vapiCallsLoaded) { loadVapiCalls(); checkVapiQueue(); } }}>
                                                <i className="feather-phone-call me-1" style={{ color: '#7c3aed' }}></i>AI Aramalar
                                                {formData?.LeadInfo?.VAPI_Skor > 0 && (
                                                    <span className="badge ms-1" style={{ background: '#7c3aed', color: '#fff' }}>{formData.LeadInfo.VAPI_Skor}</span>
                                                )}
                                            </button>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="tab-content">
                            <div className="tab-pane fade active show" id="infoTab" role="tabpanel">
                                {isLoading ? (
                                    <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="visually-hidden">Yükleniyor...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                    {/* ── Lead Profile Card ── */}
                                    <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 4px rgba(0,0,0,0.05)', marginBottom: '16px', overflow: 'hidden' }}>
                                        <div style={{ height: '4px', background: 'linear-gradient(90deg, #6366f1, #3b82f6, #06b6d4)' }}></div>
                                        <div style={{ padding: '20px 24px' }}>
                                            <div className="d-flex align-items-start gap-4 flex-wrap">
                                                {/* Avatar */}
                                                <div style={{ width: '64px', height: '64px', borderRadius: '16px', background: 'linear-gradient(135deg, #6366f1 0%, #3b82f6 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '26px', fontWeight: 700, color: '#fff', flexShrink: 0, boxShadow: '0 4px 12px rgba(99,102,241,0.25)' }}>
                                                    {formData.LeadInfo.Adi_Soyadi?.charAt(0)?.toUpperCase() || '?'}
                                                </div>
                                                {/* İsim + İletişim */}
                                                <div className="flex-grow-1 min-width-0">
                                                    <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                                                        <h5 className="mb-0 fw-bold" style={{ color: '#0f172a', fontSize: '17px' }}>{formData.LeadInfo.Adi_Soyadi}</h5>
                                                        {formData.LeadInfo.Firma_Adi && (
                                                            <span style={{ color: '#64748b', fontSize: '14px', fontWeight: 400 }}>{formData.LeadInfo.Firma_Adi}</span>
                                                        )}
                                                        <span style={{ background: '#eff6ff', color: '#3b82f6', fontSize: '11px', padding: '3px 10px', borderRadius: '20px', fontWeight: 600, border: '1px solid #bfdbfe' }}>
                                                            {formData.LeadInfo.Kaynak}
                                                        </span>
                                                        {formData.LeadInfo.Kayip && (
                                                            <span style={{ background: '#fef2f2', color: '#dc2626', fontSize: '11px', padding: '3px 10px', borderRadius: '20px', fontWeight: 600, border: '1px solid #fecaca' }}>
                                                                <i className="feather-x-circle me-1" style={{ fontSize: '10px' }}></i>Satışa Dönmedi
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="d-flex flex-wrap gap-4 mb-4" style={{ color: '#475569', fontSize: '13px' }}>
                                                        <a href={`tel:${normalizePhone(formData.LeadInfo.Telefon)}`} style={{ color: '#374151', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <i className="feather-phone" style={{ fontSize: '12px', color: '#6366f1' }}></i>
                                                            <strong>{normalizePhone(formData.LeadInfo.Telefon)}</strong>
                                                        </a>
                                                        {formData.LeadInfo.E_Posta && (
                                                            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                <i className="feather-mail" style={{ fontSize: '12px', color: '#6366f1' }}></i>
                                                                {formData.LeadInfo.E_Posta}
                                                            </span>
                                                        )}
                                                        <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            <i className="feather-calendar" style={{ fontSize: '12px', color: '#6366f1' }}></i>
                                                            {new Date(formData.LeadInfo.Tarih).toLocaleDateString('tr-TR')}
                                                        </span>
                                                        {formData.LeadInfo.Kampanya && (
                                                            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                <i className="feather-target" style={{ fontSize: '12px', color: '#6366f1' }}></i>
                                                                {formData.LeadInfo.Kampanya}
                                                            </span>
                                                        )}
                                                    </div>
                                                    {/* Aksiyon Butonları */}
                                                    <div className="d-flex flex-wrap gap-2">
                                                        <a href={`tel:${normalizePhone(formData.LeadInfo.Telefon)}`}
                                                            style={{ background: '#eff6ff', color: '#2563eb', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '6px', border: '1px solid #bfdbfe' }}>
                                                            <i className="feather-phone" style={{ fontSize: '13px' }}></i>Ara
                                                        </a>
                                                        {isFeatureEnabled('sms') && (
                                                            <button
                                                                style={{ background: '#f0f9ff', color: '#0284c7', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', fontWeight: 600, border: '1px solid #bae6fd', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                                                                data-bs-toggle="modal" data-bs-target="#sendSmsModal">
                                                                <i className="feather-message-square" style={{ fontSize: '13px' }}></i>SMS
                                                            </button>
                                                        )}
                                                        {isModuleActive('vapi') && (
                                                            <button
                                                                style={{ background: vapiCalling ? '#7c3aed' : '#faf5ff', color: vapiCalling ? '#fff' : '#7c3aed', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', fontWeight: 600, border: '1px solid #e9d5ff', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px', transition: 'all 0.15s' }}
                                                                onClick={handleVapiCall} disabled={vapiCalling}>
                                                                {vapiCalling
                                                                    ? <><span className="spinner-border spinner-border-sm" style={{ width: '12px', height: '12px' }}></span>Arıyor...</>
                                                                    : <><i className="feather-phone-call" style={{ fontSize: '13px' }}></i>AI Ara</>}
                                                            </button>
                                                        )}
                                                    </div>
                                                    {vapiQueued && (
                                                        <div style={{ marginTop: '10px', padding: '7px 14px', background: '#faf5ff', border: '1px solid #e9d5ff', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                            <span style={{ fontSize: '12px', color: '#7c3aed' }}><i className="feather-clock me-1"></i>Otomatik arama kuyruğa alındı</span>
                                                            <button style={{ fontSize: '11px', color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer', padding: '0' }} onClick={handleVapiQueueCancel}>İptal</button>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* Sağ: Yönetim Butonları */}
                                                <div className="d-flex flex-column gap-2 flex-shrink-0">
                                                    {formData.LeadInfo.Kayip ? (
                                                        <button onClick={handleKayipGeriAl}
                                                            style={{ background: '#fff', color: '#dc2626', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', fontWeight: 600, border: '1px solid #fca5a5', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                            <i className="feather-refresh-cw" style={{ fontSize: '13px' }}></i>Geri Al
                                                        </button>
                                                    ) : (
                                                        <button
                                                            style={{ background: '#fff', color: '#dc2626', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', fontWeight: 600, border: '1px solid #fca5a5', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                                                            data-bs-toggle="modal" data-bs-target="#kayipModal">
                                                            <i className="feather-x-circle" style={{ fontSize: '13px' }}></i>Kayıp İşaretle
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ── Özel Pipeline ── */}
                                    {isFeatureEnabled('pipeline') && (() => {
                                        const activeStage = pipelineStages.find(s => Number(s.Asama_ID) === Number(currentPipelineStage));
                                        const pendingStage = pipelineStages.find(s => Number(s.Asama_ID) === Number(pendingAsamaId));
                                        const pendingAltList = (() => { try { return pendingStage?.Alt_Aksiyonlar ? JSON.parse(pendingStage.Alt_Aksiyonlar) : []; } catch { return []; } })();
                                        const activeIdx = pipelineStages.findIndex(s => Number(s.Asama_ID) === Number(currentPipelineStage));
                                        return (
                                        <div style={{ background: '#fff', borderRadius: '12px', padding: '18px 20px', marginBottom: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0' }}>
                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                <div className="d-flex align-items-center gap-2">
                                                    <div style={{ width: '28px', height: '28px', borderRadius: '8px', background: '#f5f3ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                        <i className="feather-git-branch" style={{ color: '#6366f1', fontSize: '13px' }}></i>
                                                    </div>
                                                    <span style={{ fontWeight: 700, fontSize: '13px', color: '#0f172a' }}>Satış Pipeline</span>
                                                    {currentPipelineAltAksiyon && (
                                                        <span style={{ fontSize: '10px', color: '#0369a1', background: '#e0f2fe', padding: '2px 8px', borderRadius: '20px', fontWeight: 600 }}>
                                                            {currentPipelineAltAksiyon}
                                                        </span>
                                                    )}
                                                    {autoReminderDate && (
                                                        <span style={{ fontSize: '10px', color: '#92400e', background: '#fef3c7', padding: '2px 8px', borderRadius: '20px', fontWeight: 600 }}>
                                                            <i className="feather-bell" style={{ fontSize: '9px', marginRight: '3px' }}></i>{autoReminderDate} iş günü
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    {activeStage && (
                                                        <span style={{ background: activeStage.Renk + '18', color: activeStage.Renk, fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '20px', border: `1px solid ${activeStage.Renk}30` }}>
                                                            {activeStage.Tur === 'kazanildi' && <i className="feather-award me-1" style={{ fontSize: '10px' }}></i>}
                                                            {activeStage.Tur === 'kaybedildi' && <i className="feather-x-circle me-1" style={{ fontSize: '10px' }}></i>}
                                                            {activeStage.Ad}
                                                        </span>
                                                    )}
                                                    {isPipelineChanging && <span className="spinner-border spinner-border-sm" style={{ width: '14px', height: '14px', color: '#6366f1' }}></span>}
                                                    {!pipelineStages.length && (
                                                        <a href="./settings" style={{ fontSize: '11px', color: '#6366f1', textDecoration: 'none' }}>
                                                            <i className="feather-settings me-1" style={{ fontSize: '11px' }}></i>Aşama ekle
                                                        </a>
                                                    )}
                                                </div>
                                            </div>

                                            {pipelineStages.length > 0 ? (
                                                <div style={{ overflowX: 'auto', paddingBottom: '4px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'flex-start', minWidth: 'max-content' }}>
                                                        {pipelineStages.map((stage, idx) => {
                                                            const isActive = Number(currentPipelineStage) === Number(stage.Asama_ID);
                                                            const isPending = Number(pendingAsamaId) === Number(stage.Asama_ID);
                                                            const isCompleted = activeIdx > idx;
                                                            const isKazanildi = stage.Tur === 'kazanildi';
                                                            const isKaybedildi = stage.Tur === 'kaybedildi';
                                                            const stageColor = stage.Renk || '#6366f1';
                                                            const isLast = idx === pipelineStages.length - 1;
                                                            return (
                                                                <React.Fragment key={stage.Asama_ID}>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                                                                        <button
                                                                            onClick={() => handleSelectPipelineStage(stage.Asama_ID)}
                                                                            disabled={isPipelineChanging}
                                                                            title={stage.Ad}
                                                                            style={{
                                                                                width: isActive ? '36px' : '30px',
                                                                                height: isActive ? '36px' : '30px',
                                                                                borderRadius: '50%',
                                                                                border: isActive ? `3px solid ${stageColor}` : isPending ? `2px dashed ${stageColor}` : isCompleted ? `2px solid ${stageColor}` : '2px solid #e2e8f0',
                                                                                background: isActive ? stageColor : isCompleted ? stageColor + '22' : isPending ? stageColor + '12' : '#f8fafc',
                                                                                color: isActive ? '#fff' : isCompleted ? stageColor : isPending ? stageColor : '#94a3b8',
                                                                                cursor: isPipelineChanging ? 'not-allowed' : 'pointer',
                                                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                                fontSize: '11px', fontWeight: 700,
                                                                                transition: 'all 0.18s',
                                                                                boxShadow: isActive ? `0 0 0 4px ${stageColor}20` : 'none',
                                                                                flexShrink: 0, padding: 0
                                                                            }}>
                                                                            {isCompleted ? <i className="feather-check" style={{ fontSize: '10px' }}></i> :
                                                                             isKazanildi && isActive ? <i className="feather-award" style={{ fontSize: '11px' }}></i> :
                                                                             isKaybedildi && isActive ? <i className="feather-x" style={{ fontSize: '11px' }}></i> :
                                                                             <span>{idx + 1}</span>}
                                                                        </button>
                                                                        <div style={{ fontSize: '10px', fontWeight: isActive ? 700 : 500, color: isActive ? stageColor : '#64748b', maxWidth: '64px', textAlign: 'center', lineHeight: '1.2', whiteSpace: 'nowrap' }}>
                                                                            {stage.Ad}
                                                                            {stage.Hatirlatma_Gun && (
                                                                                <i className="feather-bell ms-1" style={{ fontSize: '8px', opacity: 0.5 }}></i>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {!isLast && (
                                                                        <div style={{
                                                                            height: '2px', minWidth: '20px', maxWidth: '40px', flex: '1',
                                                                            background: isCompleted || isActive ? stageColor : '#e2e8f0',
                                                                            margin: '0 4px', marginTop: '14px', transition: 'background 0.3s'
                                                                        }}></div>
                                                                    )}
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div style={{ textAlign: 'center', padding: '12px', color: '#94a3b8', fontSize: '13px', background: '#f8fafc', borderRadius: '8px' }}>
                                                    <i className="feather-inbox me-2"></i>Pipeline aşaması tanımlanmamış
                                                </div>
                                            )}

                                            {pendingAsamaId && (
                                                <div style={{ marginTop: '14px', padding: '14px 16px', background: '#f8fafc', borderRadius: '10px', border: `1px solid ${pendingStage?.Renk || '#6366f1'}28` }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 700, color: '#1e293b', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: pendingStage?.Renk, display: 'inline-block', flexShrink: 0 }}></span>
                                                        {pendingStage?.Ad}
                                                        {pendingStage?.Tur === 'kaybedildi' && (
                                                            <span style={{ fontSize: '10px', color: '#ef4444', fontWeight: 700 }}>— Kapanış Sebebi Gerekli</span>
                                                        )}
                                                    </div>
                                                    {pendingAltList.length > 0 && (
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '6px' }}>Sonuç seçin:</div>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                                                {pendingAltList.map(opt => (
                                                                    <button key={opt} type="button" onClick={() => setPendingSubAction(opt)}
                                                                        style={{
                                                                            padding: '5px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 600, cursor: 'pointer',
                                                                            border: `1.5px solid ${pendingSubAction === opt ? pendingStage?.Renk : '#e2e8f0'}`,
                                                                            background: pendingSubAction === opt ? (pendingStage?.Renk + '18') : '#fff',
                                                                            color: pendingSubAction === opt ? pendingStage?.Renk : '#475569',
                                                                            transition: 'all 0.12s'
                                                                        }}>
                                                                        {pendingSubAction === opt && <i className="feather-check me-1" style={{ fontSize: '10px' }}></i>}
                                                                        {opt}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {pendingStage?.Tur === 'kaybedildi' && (
                                                        <div style={{ marginBottom: '10px' }}>
                                                            <input type="text"
                                                                style={{ width: '100%', padding: '8px 12px', borderRadius: '8px', border: '1.5px solid #e2e8f0', fontSize: '12px', outline: 'none', background: '#fff' }}
                                                                placeholder="Kapanış sebebi... (ör: Bütçe yok, Rakip seçildi)"
                                                                value={closingReason} onChange={e => setClosingReason(e.target.value)}
                                                                onKeyDown={e => e.key === 'Enter' && handleConfirmPipelineChange()} autoFocus />
                                                        </div>
                                                    )}
                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        <button type="button" onClick={handleConfirmPipelineChange} disabled={isPipelineChanging}
                                                            style={{ padding: '6px 18px', borderRadius: '8px', border: 'none', background: pendingStage?.Renk, color: '#fff', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>
                                                            {isPipelineChanging ? <span className="spinner-border spinner-border-sm" style={{ width: '12px', height: '12px' }} /> : <><i className="feather-check me-1"></i>Onayla</>}
                                                        </button>
                                                        <button type="button" onClick={handleCancelPipelineChange}
                                                            style={{ padding: '6px 14px', borderRadius: '8px', border: '1px solid #e2e8f0', background: '#fff', color: '#64748b', fontSize: '12px', cursor: 'pointer' }}>
                                                            İptal
                                                        </button>
                                                    </div>
                                                </div>
                                            )}

                                            {(currentPipelineStage || currentPipelineAltAksiyon) && !pendingAsamaId && (
                                                <div className="d-flex justify-content-between align-items-center mt-2">
                                                    <div style={{ fontSize: '11px', color: '#64748b' }}>
                                                        {currentPipelineAltAksiyon && <span>Sonuç: <strong>{currentPipelineAltAksiyon}</strong></span>}
                                                        {formData.LeadInfo?.Pipeline_Kapanis_Nedeni && <span className="ms-2">Sebep: <strong>{formData.LeadInfo.Pipeline_Kapanis_Nedeni}</strong></span>}
                                                    </div>
                                                    <button className="btn btn-link text-muted p-0" style={{ fontSize: '11px' }}
                                                        onClick={() => applyPipelineChange(null, null, null)} disabled={isPipelineChanging}>
                                                        <i className="feather-x me-1"></i>Aşamayı kaldır
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        );
                                    })()}
                                    {/* Info Cards */}
                                    <div className="row g-3">
                                        {/* Sol: Müşteri Bilgileri */}
                                        <div className="col-lg-6">
                                            <div className="card h-100" style={{ border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                                                <div className="card-header py-3 d-flex align-items-center gap-2" style={{ borderBottom: '1px solid #f1f5f9', background: '#fff' }}>
                                                    <div style={{ width: '28px', height: '28px', borderRadius: '8px', background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                        <i className="feather-user" style={{ color: '#3b82f6', fontSize: '14px' }}></i>
                                                    </div>
                                                    <h6 className="mb-0 fw-bold" style={{ fontSize: '13px', color: '#0f172a' }}>Müşteri Bilgileri</h6>
                                                </div>
                                                <div className="card-body p-0">
                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-user text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Ad Soyad</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>{formData.LeadInfo.Adi_Soyadi}</div>
                                                        </div>
                                                        <button className="btn btn-link text-primary p-0 ms-2" data-bs-toggle="modal" data-bs-target="#editNameSurname">
                                                            <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                        </button>
                                                    </div>

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-briefcase text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Firma Adı</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>{formData.LeadInfo.Firma_Adi || <span className="text-muted">Belirtilmemiş</span>}</div>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-mail text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>E-Posta</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>{formData.LeadInfo.E_Posta || <span className="text-muted">—</span>}</div>
                                                        </div>
                                                        <button className="btn btn-link text-primary p-0 ms-2" data-bs-toggle="modal" data-bs-target="#editEmail">
                                                            <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                        </button>
                                                    </div>

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-phone text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Telefon</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>{normalizePhone(formData.LeadInfo.Telefon)}</div>
                                                        </div>
                                                        <button className="btn btn-link text-primary p-0 ms-2" data-bs-toggle="modal" data-bs-target="#editPhoneNumber">
                                                            <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                        </button>
                                                    </div>

                                                    {formData.LeadInfo.Mesaj && (
                                                        <div className="d-flex align-items-start px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                            <i className="feather-message-circle text-muted me-3 mt-1" style={{ width: '16px' }}></i>
                                                            <div className="flex-grow-1 min-width-0">
                                                                <div className="text-muted" style={{ fontSize: '11px' }}>Mesaj</div>
                                                                <div className="fw-semibold text-truncate" style={{ fontSize: '13px', maxWidth: '260px' }}>{formData.LeadInfo.Mesaj}</div>
                                                            </div>
                                                            {formData.LeadInfo.Mesaj.length > 30 && (
                                                                <button className="btn btn-link text-primary p-0 ms-2" onClick={() => showFullText(formData.LeadInfo.Mesaj)}>
                                                                    <i className="feather-eye" style={{ fontSize: '13px' }}></i>
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}

                                                    {formData.LeadInfo.Soru && (
                                                        <div className="d-flex align-items-start px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                            <i className="feather-help-circle text-muted me-3 mt-1" style={{ width: '16px' }}></i>
                                                            <div className="flex-grow-1">
                                                                <div className="text-muted" style={{ fontSize: '11px' }}>Soru</div>
                                                                <div className="fw-semibold" style={{ fontSize: '13px' }}>{formData.LeadInfo.Soru}</div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {formData.LeadInfo.Website && (
                                                        <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                            <i className="feather-link text-muted me-3" style={{ width: '16px' }}></i>
                                                            <div className="flex-grow-1">
                                                                <div className="text-muted" style={{ fontSize: '11px' }}>Website</div>
                                                                <a href={formData.LeadInfo.Website.startsWith('http') ? formData.LeadInfo.Website : `https://${formData.LeadInfo.Website}`} target="_blank" rel="noopener noreferrer" className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                    {formData.LeadInfo.Website}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-globe text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Kaynak</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>{formData.LeadInfo.Kaynak}</div>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-target text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Kampanya</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>{formData.LeadInfo.Kampanya || <span className="text-muted">—</span>}</div>
                                                        </div>
                                                    </div>

                                                    {formData.LeadInfo.Gorsel && (
                                                        <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                            <i className="feather-image text-muted me-3" style={{ width: '16px' }}></i>
                                                            <div className="flex-grow-1">
                                                                <div className="text-muted" style={{ fontSize: '11px' }}>Kampanya Görseli</div>
                                                                <img src={formData.LeadInfo.Gorsel} width={60} className="rounded mt-1" alt="kampanya" />
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="d-flex align-items-center px-3 py-2">
                                                        <i className="feather-calendar text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Form Tarihi</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {new Date(formData.LeadInfo.Tarih).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', '')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Sağ: CRM Detayları */}
                                        <div className="col-lg-6">
                                            <div className="card h-100" style={{ border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                                                <div className="card-header py-3 d-flex align-items-center gap-2" style={{ borderBottom: '1px solid #f1f5f9', background: '#fff' }}>
                                                    <div style={{ width: '28px', height: '28px', borderRadius: '8px', background: '#f0fdf4', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                        <i className="feather-activity" style={{ color: '#10b981', fontSize: '14px' }}></i>
                                                    </div>
                                                    <h6 className="mb-0 fw-bold" style={{ fontSize: '13px', color: '#0f172a' }}>CRM Detayları</h6>
                                                </div>
                                                <div className="card-body p-0">

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-bell text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Hatırlatma Tarihi</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {formData.Hatirlatma_Tarihi ? (() => {
                                                                    const d = new Date(formData.Hatirlatma_Tarihi);
                                                                    const isOverdue = d < new Date();
                                                                    const isToday = d.toDateString() === new Date().toDateString();
                                                                    return (
                                                                        <span className={isOverdue && !isToday ? 'text-danger' : isToday ? 'text-warning' : ''}>
                                                                            {isOverdue && !isToday && <i className="feather-alert-circle me-1" style={{ fontSize: '11px' }}></i>}
                                                                            {d.toLocaleString('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).replace(',', '')}
                                                                            {isOverdue && !isToday && <span className="ms-1 badge bg-danger" style={{ fontSize: '10px' }}>Geç Kaldı</span>}
                                                                            {isToday && <span className="ms-1 badge bg-warning text-dark" style={{ fontSize: '10px' }}>Bugün</span>}
                                                                        </span>
                                                                    );
                                                                })() : <span className="text-muted">Belirtilmemiş</span>}
                                                            </div>
                                                        </div>
                                                        <div className="d-flex gap-1 ms-2">
                                                            <button className="btn btn-link text-primary p-0" data-bs-toggle="modal" data-bs-target="#editReminder"
                                                                onClick={() => { if (!reminderDate) { const now = new Date(); now.setSeconds(0, 0); setReminderDate(now.toISOString().slice(0, 16)); } }}>
                                                                <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                            </button>
                                                            <button className="btn btn-link text-danger p-0" onClick={deleteReminder}>
                                                                <i className="feather-trash-2" style={{ fontSize: '13px' }}></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {/* Satış Temsilcisi */}
                                                    {isAdmin && (
                                                    <TemsilciRow
                                                        formID={formID}
                                                        temsilciId={formData.Temsilci_ID}
                                                        temsilciIsim={formData.Temsilci_Isim}
                                                        temsilciler={temsilciler}
                                                        onSaved={(id, isim) => setFormData(prev => ({ ...prev, Temsilci_ID: id, Temsilci_Isim: isim }))}
                                                    />
                                                    )}

                                                    {isFeatureEnabled('call_count') && (
                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-phone-call text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Arama Sayısı</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                <NumberInput initialCount={formData.Arama_Sayisi || 0} onUpdateNumber={changeCallCount} loading={changeCallCountLoading} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    )}

                                                    <div className="d-flex align-items-start px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-tag text-muted me-3 mt-1" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Etiketler</div>
                                                            <div className="d-flex flex-wrap gap-1 mt-1">
                                                                {formData.Etiketler.map((etiket) => (
                                                                    <a key={etiket.Etiket_ID} href="javascript:void(0);" onClick={() => deleteEtiket(etiket.Etiket_ID, "label")} className="badge" style={{ backgroundColor: "#" + etiket.Etiket_Renk, color: "#" + etiket.Etiket_Yazi_Renk, fontSize: '11px' }}>
                                                                        {etiket.Etiket_Adi}
                                                                    </a>
                                                                ))}
                                                                <button className="badge bg-light text-muted border-0" style={{ fontSize: '11px' }} data-bs-toggle="modal" data-bs-target="#addEtiket">
                                                                    <i className="feather-plus"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-start px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-file-text text-muted me-3 mt-1" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Açıklama</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>{formData.LeadInfo.Aciklama || <span className="text-muted">—</span>}</div>
                                                        </div>
                                                        <button className="btn btn-link text-primary p-0 ms-2" data-bs-toggle="modal" data-bs-target="#editAciklama">
                                                            <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                        </button>
                                                    </div>

                                                    {isFeatureEnabled('visit_date') && (
                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-headphones text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Tel/Mail Görüşme Zamanı</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {formData.LeadInfo.Ziyaret_Tarihi && !isNaN(new Date(formData.LeadInfo.Ziyaret_Tarihi).getTime())
                                                                    ? new Date(formData.LeadInfo.Ziyaret_Tarihi).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', '')
                                                                    : <span className="text-muted">Belirtilmemiş</span>}
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-link text-primary p-0 ms-2" data-bs-toggle="modal" data-bs-target="#editVisitDate">
                                                            <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                        </button>
                                                    </div>
                                                    )}

                                                    {isFeatureEnabled('meet_count') && (
                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-users text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Görüşme Sayısı</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>{formData.LeadInfo.Gorusme_Sayisi || 0}</div>
                                                        </div>
                                                        <button className="btn btn-link text-primary p-0 ms-2" data-bs-toggle="modal" data-bs-target="#editMeetCount">
                                                            <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                        </button>
                                                    </div>
                                                    )}

                                                    {isFeatureEnabled('meeting_info') && (
                                                    <>
                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-phone text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Arama Tarihi</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {aramaTarihi
                                                                    ? new Date(aramaTarihi).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', '')
                                                                    : <span className="text-muted">Aranmadı</span>}
                                                            </div>
                                                        </div>
                                                        {aramaTarihi && (
                                                            <span className={`badge ms-2 ${ulasimDurumu === 1 ? 'bg-success' : ulasimDurumu === 0 ? 'bg-warning text-dark' : 'bg-secondary'}`} style={{ fontSize: '10px' }}>
                                                                {ulasimDurumu === 1 ? 'Ulaşıldı' : ulasimDurumu === 0 ? 'Ulaşılamadı' : 'Belirsiz'}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-calendar text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Toplantı Talep Tarihi</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {toplantıTalepTarihi
                                                                    ? new Date(toplantıTalepTarihi).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', '')
                                                                    : <span className="text-muted">—</span>}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-users text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Toplantı Tarihi</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {toplantıTarihi
                                                                    ? new Date(toplantıTarihi).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', '')
                                                                    : <span className="text-muted">—</span>}
                                                            </div>
                                                        </div>
                                                        {toplantıTarihi && (
                                                            <button className="btn btn-link text-primary p-0 ms-2" data-bs-toggle="modal" data-bs-target="#editToplantıTarihi">
                                                                <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                    </>
                                                    )}

                                                    {isFeatureEnabled('teklif_date') && (
                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-send text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Teklif İletme Tarihi</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {formData.LeadInfo.Teklif_Tarihi && !String(formData.LeadInfo.Teklif_Tarihi).startsWith('0000') && !isNaN(new Date(formData.LeadInfo.Teklif_Tarihi).getTime())
                                                                    ? new Date(formData.LeadInfo.Teklif_Tarihi).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', '')
                                                                    : <span className="text-muted">Belirtilmemiş</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    )}

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: formData.LeadInfo.Kayip ? '1px solid #f8f9fa' : 'none' }}>
                                                        <i className="feather-check-circle text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Satış Tarihi</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {formData.LeadInfo.Satis_Tarihi && !String(formData.LeadInfo.Satis_Tarihi).startsWith('0000') && !isNaN(new Date(formData.LeadInfo.Satis_Tarihi).getTime())
                                                                    ? new Date(formData.LeadInfo.Satis_Tarihi).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', '')
                                                                    : <span className="text-muted">Belirtilmemiş</span>}
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-link text-primary p-0 ms-2" data-bs-toggle="modal" data-bs-target="#editSellDate">
                                                            <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                        </button>
                                                    </div>

                                                    {formData.LeadInfo.Kayip && (
                                                        <div className="d-flex align-items-center px-3 py-2">
                                                            <i className="feather-x-circle text-danger me-3" style={{ width: '16px' }}></i>
                                                            <div className="flex-grow-1">
                                                                <div className="text-muted" style={{ fontSize: '11px' }}>Satışa Dönmeme Nedeni</div>
                                                                <div className="text-danger fw-semibold" style={{ fontSize: '13px' }}>{formData.LeadInfo.Kayip_Neden || 'Belirtilmemiş'}</div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Fırsat Bilgileri */}
                                    {(() => {
                                        const currentStage = pipelineStages.find(s => Number(s.Asama_ID) === Number(currentPipelineStage));
                                        const kapanmaYuzdesi = currentStage?.Kapanma_Yuzdesi ?? 0;
                                        const agirlikliCiro = (formData.LeadInfo.Teklif_Tutari || 0) * (kapanmaYuzdesi / 100);
                                        const isStageClosed = currentStage && (currentStage.Tur === 'kazanildi' || currentStage.Tur === 'kaybedildi');
                                        const bkTarih = formData.LeadInfo.Beklenen_Kapanis_Tarihi ? new Date(formData.LeadInfo.Beklenen_Kapanis_Tarihi) : null;
                                        const bkOverdue = bkTarih && bkTarih < new Date(new Date().toDateString()) && !isStageClosed;
                                        const saTarih = formData.LeadInfo.Sonraki_Aksiyon_Tarihi ? new Date(formData.LeadInfo.Sonraki_Aksiyon_Tarihi) : null;
                                        const saOverdue = saTarih && saTarih < new Date(new Date().toDateString()) && !isStageClosed;

                                        return (
                                            <div className="card mt-3" style={{ border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
                                                <div className="card-header py-3 d-flex align-items-center gap-2" style={{ borderBottom: '1px solid #f1f5f9', background: '#fff' }}>
                                                    <div style={{ width: '28px', height: '28px', borderRadius: '8px', background: '#fef3c7', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                        <i className="feather-target" style={{ color: '#d97706', fontSize: '14px' }}></i>
                                                    </div>
                                                    <h6 className="mb-0 fw-bold" style={{ fontSize: '13px', color: '#0f172a' }}>Fırsat Bilgileri</h6>
                                                </div>
                                                <div className="card-body p-0">

                                                    {isAdmin && (
                                                    <TeklifTutariRow
                                                        formID={formID}
                                                        teklifTutari={formData.LeadInfo.Teklif_Tutari}
                                                        onSaved={(v) => setFormData(prev => ({ ...prev, LeadInfo: { ...prev.LeadInfo, Teklif_Tutari: v } }))}
                                                    />
                                                    )}

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-flag text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Beklenen Kapanış Tarihi</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {bkTarih ? (
                                                                    <span className={bkOverdue ? 'text-danger' : ''}>
                                                                        {bkOverdue && <i className="feather-alert-circle me-1" style={{ fontSize: '11px' }}></i>}
                                                                        {bkTarih.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                                                        {bkOverdue && <span className="ms-1 badge bg-danger" style={{ fontSize: '10px' }}>Geç Kaldı</span>}
                                                                    </span>
                                                                ) : <span className="text-muted">Belirtilmemiş</span>}
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-link text-primary p-0 ms-2" data-bs-toggle="modal" data-bs-target="#editBeklenenKapanisTarihi">
                                                            <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                        </button>
                                                    </div>

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-arrow-right-circle text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Sonraki Aksiyon Tarihi</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {saTarih ? (
                                                                    <span className={saOverdue ? 'text-danger' : ''}>
                                                                        {saOverdue && <i className="feather-alert-circle me-1" style={{ fontSize: '11px' }}></i>}
                                                                        {saTarih.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                                                        {saOverdue && <span className="ms-1 badge bg-danger" style={{ fontSize: '10px' }}>Geç Kaldı</span>}
                                                                    </span>
                                                                ) : <span className="text-muted">Belirtilmemiş</span>}
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-link text-primary p-0 ms-2" data-bs-toggle="modal" data-bs-target="#editSonrakiAksiyonTarihi">
                                                            <i className="feather-edit-2" style={{ fontSize: '13px' }}></i>
                                                        </button>
                                                    </div>

                                                    <div className="d-flex align-items-center px-3 py-2" style={{ borderBottom: '1px solid #f8f9fa' }}>
                                                        <i className="feather-percent text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Kapanma İhtimali</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {currentStage ? `%${kapanmaYuzdesi}` : <span className="text-muted">—</span>}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {isAdmin && (
                                                    <div className="d-flex align-items-center px-3 py-2">
                                                        <i className="feather-trending-up text-muted me-3" style={{ width: '16px' }}></i>
                                                        <div className="flex-grow-1">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>Ağırlıklı Ciro</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>
                                                                {formatCurrency(agirlikliCiro)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    )}

                                                </div>
                                            </div>
                                        );
                                    })()}

                                    {/* UTM & Reklam Bilgileri - Collapsible */}
                                    {isFeatureEnabled('utm_info') && (
                                    <div className="card mt-3">
                                        <div className="card-header py-2 d-flex align-items-center justify-content-between"
                                            style={{ cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                                            data-bs-toggle="collapse" data-bs-target="#utmCollapse">
                                            <div className="d-flex align-items-center gap-2">
                                                <i className="feather-trending-up text-muted"></i>
                                                <h6 className="mb-0 fw-semibold text-muted" style={{ fontSize: '13px' }}>UTM & Reklam Bilgileri</h6>
                                            </div>
                                            <i className="feather-chevron-down text-muted" style={{ fontSize: '14px' }}></i>
                                        </div>
                                        <div id="utmCollapse" className="collapse">
                                            <div className="card-body">
                                                <div className="row g-3">
                                                    {[
                                                        { label: 'UTM Kaynak', value: formData.LeadInfo.UTM_Source },
                                                        { label: 'UTM Medium', value: formData.LeadInfo.UTM_Medium },
                                                        { label: 'UTM Kampanya', value: formData.LeadInfo.UTM_Campaign },
                                                        { label: 'UTM Kelime', value: formData.LeadInfo.UTM_Kelime },
                                                        { label: 'UTM Reklam Grubu', value: formData.LeadInfo.UTM_Reklam_Grubu },
                                                    ].map((item, i) => (
                                                        <div key={i} className="col-sm-6 col-md-4">
                                                            <div className="text-muted" style={{ fontSize: '11px' }}>{item.label}</div>
                                                            <div className="fw-semibold" style={{ fontSize: '13px' }}>{item.value || <span className="text-muted">—</span>}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                    </>
                                )}
                            </div>
                            <div className="tab-pane fade" id="notesTab" role="tabpanel">
                                {/* Inline not ekleme formu */}
                                <div className="card card-body mb-3" style={{ borderLeft: '3px solid #0d6efd' }}>
                                    <div className="mb-2">
                                        <input
                                            className="form-control form-control-sm mb-2"
                                            type="text"
                                            placeholder="Not başlığı..."
                                            value={noteTitle}
                                            onChange={(e) => setNoteTitle(e.target.value)}
                                        />
                                        <textarea
                                            className="form-control form-control-sm"
                                            rows={3}
                                            placeholder="Not içeriği..."
                                            value={noteDesc}
                                            onChange={(e) => setNoteDesc(e.target.value)}
                                        />
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <button className="btn btn-sm btn-primary" onClick={() => createNote(false)}>
                                            <i className="feather-plus me-1"></i>Not Ekle
                                        </button>
                                    </div>
                                </div>
                                <div className="card card-body">
                                    <div class="row note-has-grid" id="note-full-container">
                                        {notes.length > 0 ? (
                                            <>
                                                {notes.map((not, index) => (
                                                    <div key={"note_" + not.Not_ID} className="col-xxl-4 col-xl-6 col-lg-4 col-sm-6 single-note-item all-category note-important note-tasks">
                                                        <div className="card card-body mb-4 stretch stretch-full">
                                                            <span className="side-stick"></span>
                                                            <button onClick={(e) => viewNote(not.Not_ID)} data-bs-toggle="modal" data-bs-target="#viewNote" className="avatar-text avatar-md" style={{ position: 'absolute', right: '15px', top: '15px' }}><i className="feather-eye"></i></button>
                                                            <h5 className="note-title text-truncate w-75 mb-1" data-noteheading={not.Not_Basligi}>{not.Not_Basligi}</h5>
                                                            <p className="fs-11 text-muted note-date">{not.Not_Tarihi}</p>
                                                            <div className="note-content flex-grow-1">
                                                                <p className="text-muted note-inner-content text-truncate-3-line" data-notecontent={not.Not_Aciklamasi}>{not.Not_Aciklamasi}</p>
                                                            </div>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <button onClick={(e) => deleteNote(not.Not_ID)} className="avatar-text avatar-md"><i className="feather-trash-2 remove-note"></i></button>
                                                                <div className="ms-auto d-flex gap-2 align-items-center">
                                                                    <img src={not.Kullanici.Profil_Gorseli || DEFAULT_AVATAR} className="avatar avatar-sm"
                                                                        onError={e => { e.target.onerror = null; e.target.src = DEFAULT_AVATAR; }} />
                                                                    <span className="fw-bold">{not.Kullanici.Kullanici_Adi} {not.Kullanici.Kullanici_Soyadi}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                <div className="col-xxl-4 col-xl-6 col-lg-4 col-sm-6 single-note-item all-category note-important note-tasks">
                                                    <div className="card card-body mb-4 strech strech-full">
                                                        <span className="side-stick"></span>
                                                        <h5 className="note-title text-truncate w-75 mb-1" data-noteheading=""></h5>
                                                        <p className="fs-11 text-muted note-date"></p>
                                                        <div className="note-content flex-grow-1">
                                                            <p className="text-muted note-inner-content text-truncate-3-line" data-notecontent=""></p>
                                                        </div>
                                                        <p></p>
                                                        <a href="javascript:void(0);" className="avatar-text bg-soft-primary text-primary mx-auto" data-bs-toggle="modal" data-bs-target="#addNote" data-bs-tooltip="tooltip" title="Yeni Not">
                                                            <i className="feather-plus"></i>
                                                        </a>
                                                        <span></span>
                                                        <div className="d-flex align-items-center gap-1 invisible pe-none">
                                                            <button className="avatar-text avatar-md"><i className="feather-trash-2 remove-note"></i></button>
                                                            <div className="ms-auto d-flex gap-2 align-items-center">
                                                                <img src="" className="avatar avatar-sm" />
                                                                <span className="fw-bold">LEVELUP CRM</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="d-flex align-items-center justify-content-center" style={{ height: "calc(100vh - 315px)" }}>
                                                <div className="text-center">
                                                    <h2 className="fs-16 fw-semibold">Not bulunamadı!</h2>
                                                    <p className="fs-12 text-muted">Henüz herhangi bir not kayıt edilmemiş.</p>
                                                    <a href="javascript:void(0);" className="avatar-text bg-soft-primary text-primary mx-auto" data-bs-toggle="modal" data-bs-target="#addNote" data-bs-tooltip="tooltip" title="Yeni Not">
                                                        <i className="feather-plus"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="filesTab" role="tabpanel">
                                <input type="file" className="d-none" id="uploadFileInput" ref={uploadFileInput} onChange={uploadFile} />
                                <div className="card card-body">
                                    <div class="row note-has-grid" id="files-full-container">
                                        {files.length > 0 ? (
                                            <>
                                                {files.map((file, index) => (
                                                    <div key={"file_" + file.Not_ID} className="col-xxl-4 col-xl-6 col-lg-4 col-sm-6 single-note-item all-category note-important note-tasks">
                                                        <div className="card card-body mb-4 stretch stretch-full">
                                                            <span className="side-stick"></span>
                                                            <a href={file.Dosya_Yolu} target="_blank" className="avatar-text avatar-md" style={{ position: 'absolute', right: '15px', top: '15px' }}><i className="feather-eye"></i></a>
                                                            <h5 className="note-title text-truncate w-75 mb-1" data-noteheading={file.Dosya_Yolu.split('/').pop()}>{file.Dosya_Yolu.split('/').pop()}</h5>
                                                            <p className="fs-11 text-muted note-date">{file.Dosya_Tarihi}</p>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <button onClick={(e) => deleteFile(file.Dosya_ID)} className="avatar-text avatar-md"><i className="feather-trash-2 remove-note"></i></button>
                                                                <div className="ms-auto d-flex gap-2 align-items-center">
                                                                    <img src={file.Kullanici.Profil_Gorseli || DEFAULT_AVATAR} className="avatar avatar-sm"
                                                                        onError={e => { e.target.onerror = null; e.target.src = DEFAULT_AVATAR; }} />
                                                                    <span className="fw-bold">{file.Kullanici.Kullanici_Adi} {file.Kullanici.Kullanici_Soyadi}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                <div className="col-xxl-4 col-xl-6 col-lg-4 col-sm-6 single-note-item all-category note-important note-tasks">
                                                    <div className="card card-body mb-4 strech strech-full">
                                                        <span className="side-stick"></span>
                                                        <h5 className="note-title text-truncate w-75 mb-1" data-noteheading=""></h5>
                                                        <p className="fs-11 text-muted note-date"></p>
                                                        <button onClick={(e) => uploadFileInput.current.click()} className="avatar-text bg-soft-primary text-primary mx-auto" data-bs-tooltip="tooltip" title="Dosya Yükle">
                                                            <i className="feather-plus"></i>
                                                        </button>
                                                        <div className="d-flex align-items-center gap-1 invisible pe-none">
                                                            <button className="avatar-text avatar-md"><i className="feather-trash-2 remove-note"></i></button>
                                                            <div className="ms-auto d-flex gap-2 align-items-center">
                                                                <img src="" className="avatar avatar-sm" />
                                                                <span className="fw-bold">LEVELUP CRM</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="d-flex align-items-center justify-content-center" style={{ height: "calc(100vh - 315px)" }}>
                                                <div className="text-center">
                                                    <h2 className="fs-16 fw-semibold">Dosya bulunamadı!</h2>
                                                    <p className="fs-12 text-muted">Henüz herhangi bir dosya yüklenmemiş.</p>
                                                    <button onClick={(e) => uploadFileInput.current.click()} className="avatar-text bg-soft-primary text-primary mx-auto" data-bs-tooltip="tooltip" title="Dosya Yükle">
                                                        <i className="feather-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* ── VAPI AI Aramalar Sekmesi ──────────────────────── */}
                            <div className="tab-pane fade" id="vapiTab" role="tabpanel">
                                <div className="card card-body">

                                    {/* Başlık + Manuel Arama Butonu */}
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <div>
                                            <h6 className="fw-bold mb-1" style={{ color: '#7c3aed' }}>
                                                <i className="feather-phone-call me-2"></i>AI Arama Geçmişi
                                            </h6>
                                            {formData?.LeadInfo?.VAPI_Skor > 0 && (
                                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                                    <span className="badge" style={{ background: '#7c3aed', color: '#fff', fontSize: '12px' }}>
                                                        Skor: {formData.LeadInfo.VAPI_Skor}/100
                                                    </span>
                                                    <span className="badge" style={{
                                                        background: { 'çok sıcak': '#10b981', 'sıcak': '#f97316', 'ılık': '#f59e0b', 'soğuk': '#6b7280' }[formData.LeadInfo.VAPI_Iliski_Durumu] || '#6b7280',
                                                        color: '#fff', fontSize: '12px'
                                                    }}>
                                                        {(formData.LeadInfo.VAPI_Iliski_Durumu || 'soğuk').toUpperCase()}
                                                    </span>
                                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                                        Son arama: {formData.LeadInfo.VAPI_Son_Arama ? new Date(formData.LeadInfo.VAPI_Son_Arama).toLocaleString('tr-TR') : '—'}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <button className="btn btn-sm btn-light" onClick={() => loadVapiCalls()} style={{ borderRadius: '8px', fontSize: '12px' }}>
                                                <i className="feather-refresh-cw me-1"></i>Yenile
                                            </button>
                                            <button className="btn btn-sm text-white fw-semibold" onClick={handleVapiCall} disabled={vapiCalling}
                                                style={{ background: '#7c3aed', border: 'none', borderRadius: '8px', fontSize: '12px' }}>
                                                {vapiCalling ? <><span className="spinner-border spinner-border-sm me-1" style={{ width: '10px', height: '10px' }}></span>Arıyor...</> : <><i className="feather-phone-call me-1"></i>Manuel Ara</>}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Aranıyor durumunda uyarı */}
                                    {vapiCalls.some(c => c.Durum === 'aranıyor') && (
                                        <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '10px', padding: '10px 14px', marginBottom: '12px', fontSize: '12px', color: '#1d4ed8' }}>
                                            <i className="feather-info me-2"></i>
                                            <strong>Arama devam ediyor.</strong> Arama bittiğinde VAPI webhook tetikler ve analiz otomatik eklenir.
                                            Arama gelmiyorsa VAPI panelinde <strong>Phone Numbers</strong> → <strong>Phone Number ID</strong>'nin doğru girildiğini kontrol edin (UUID formatında olmalı, gerçek numara değil).
                                            <button className="btn btn-sm btn-outline-primary ms-2 py-0 px-2" style={{ fontSize: '11px' }} onClick={() => loadVapiCalls()}>
                                                Yenile
                                            </button>
                                        </div>
                                    )}

                                    {/* Arama Listesi */}
                                    {vapiCalls.length === 0 ? (
                                        <div className="text-center py-5 text-muted">
                                            <i className="feather-phone-off" style={{ fontSize: '36px', color: '#ddd', display: 'block', marginBottom: '12px' }}></i>
                                            <div style={{ fontWeight: 600, marginBottom: '4px' }}>Henüz AI arama yok</div>
                                            <div style={{ fontSize: '12px' }}>Manuel ara veya otomatik aramanın devreye girmesini bekleyin</div>
                                        </div>
                                    ) : (
                                        vapiCalls.map(call => (
                                            <div key={call.Arama_ID} style={{
                                                border: `1px solid ${call.Durum === 'tamamlandi' ? '#e9d5ff' : '#e5e7eb'}`,
                                                borderRadius: '12px', marginBottom: '12px', overflow: 'hidden',
                                                background: call.Durum === 'tamamlandi' ? '#faf5ff' : '#fafafa'
                                            }}>
                                                {/* Call header */}
                                                <div style={{ padding: '12px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                                                    onClick={() => setVapiExpandedCall(vapiExpandedCall === call.Arama_ID ? null : call.Arama_ID)}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                        <div style={{
                                                            width: '36px', height: '36px', borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            background: { 'tamamlandi': '#7c3aed', 'cevapsiz': '#f59e0b', 'mesgul': '#ef4444', 'basarisiz': '#6b7280', 'aranıyor': '#3b82f6' }[call.Durum] || '#d1d5db',
                                                            color: '#fff', fontSize: '14px'
                                                        }}>
                                                            <i className={call.Durum === 'aranıyor' ? 'feather-loader' : 'feather-phone-call'}></i>
                                                        </div>
                                                        <div>
                                                            <div style={{ fontWeight: 700, fontSize: '13px', color: '#111' }}>
                                                                {call.Tetikleyen === 'otomatik' ? '🤖 Otomatik' : '👤 Manuel'} Arama
                                                                <span className="badge ms-2" style={{ fontSize: '10px', background: { 'tamamlandi': '#7c3aed', 'cevapsiz': '#f59e0b', 'mesgul': '#ef4444', 'basarisiz': '#6b7280', 'aranıyor': '#3b82f6', 'bekliyor': '#d1d5db' }[call.Durum] || '#d1d5db', color: '#fff' }}>
                                                                    {call.Durum}
                                                                </span>
                                                                {call.Skor > 0 && <span className="badge ms-1" style={{ background: '#10b981', color: '#fff', fontSize: '10px' }}>{call.Skor}/100</span>}
                                                            </div>
                                                            <div style={{ fontSize: '11px', color: '#888' }}>
                                                                {new Date(call.Tarih).toLocaleString('tr-TR')}
                                                                {call.Sure_Saniye > 0 && <span className="ms-2">⏱ {Math.floor(call.Sure_Saniye / 60)}dk {call.Sure_Saniye % 60}sn</span>}
                                                                {call.Arayan && <span className="ms-2">👤 {call.Arayan}</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <i className={`feather-chevron-${vapiExpandedCall === call.Arama_ID ? 'up' : 'down'}`} style={{ color: '#888' }}></i>
                                                </div>

                                                {/* Expanded: Analiz + Transcript */}
                                                {vapiExpandedCall === call.Arama_ID && (
                                                    <div style={{ padding: '0 16px 16px', borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                                                        {/* Debug bilgisi */}
                                                        <div style={{ background: '#f8f9fa', borderRadius: '8px', padding: '10px 12px', marginTop: '12px', fontSize: '11px', color: '#666', display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
                                                            <span><strong>Aranan:</strong> {call.Aranan_Numara || '—'}</span>
                                                            <span><strong>VAPI Call ID:</strong> {call.VAPI_Call_ID || '—'}</span>
                                                            <span><strong>Durum:</strong> {call.Durum}</span>
                                                            {call.VAPI_Call_ID && call.Durum === 'aranıyor' && (
                                                                <button className="btn btn-sm btn-outline-secondary py-0 px-2" style={{ fontSize: '11px' }}
                                                                    onClick={async () => {
                                                                        try {
                                                                            const r = await get(`vapi/status/${call.VAPI_Call_ID}`);
                                                                            const s = r?.call;
                                                                            toast.info(`VAPI durumu: ${s?.status || '?'} | endedReason: ${s?.endedReason || '—'} | to: ${s?.customer?.number || '—'}`, { autoClose: 12000 });
                                                                        } catch(e) {
                                                                            toast.error('Durum alınamadı: ' + (e?.response?.data?.message || e.message));
                                                                        }
                                                                    }}>
                                                                    VAPI Durumu Sorgula
                                                                </button>
                                                            )}
                                                        </div>
                                                        {call.AI_Analiz && (
                                                            <div style={{ background: '#fff', borderRadius: '8px', padding: '14px', marginTop: '12px', border: '1px solid #ede9fe' }}>
                                                                <div style={{ fontWeight: 700, fontSize: '13px', color: '#7c3aed', marginBottom: '10px' }}>📊 AI Analiz</div>
                                                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '10px' }}>
                                                                    {[
                                                                        { label: 'İlgi', val: call.AI_Analiz.ilgi_skoru, max: 25 },
                                                                        { label: 'Bütçe', val: call.AI_Analiz.butce_skoru, max: 25 },
                                                                        { label: 'Aciliyet', val: call.AI_Analiz.aciliyet_skoru, max: 25 },
                                                                        { label: 'Uygunluk', val: call.AI_Analiz.uygunluk_skoru, max: 25 },
                                                                    ].map(item => (
                                                                        <div key={item.label}>
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', marginBottom: '3px' }}>
                                                                                <span style={{ color: '#666' }}>{item.label}</span>
                                                                                <span style={{ fontWeight: 700, color: '#7c3aed' }}>{item.val || 0}/{item.max}</span>
                                                                            </div>
                                                                            <div style={{ height: '6px', borderRadius: '3px', background: '#f0f0f0' }}>
                                                                                <div style={{ height: '100%', borderRadius: '3px', background: '#7c3aed', width: `${((item.val || 0) / item.max) * 100}%`, transition: 'width 0.3s' }}></div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                {call.AI_Analiz.ozet && <p style={{ fontSize: '12px', color: '#444', margin: '0 0 8px' }}><strong>Özet:</strong> {call.AI_Analiz.ozet}</p>}
                                                                {call.AI_Analiz.sonraki_adim && <p style={{ fontSize: '12px', color: '#10b981', margin: 0 }}><strong>Sonraki Adım:</strong> {call.AI_Analiz.sonraki_adim}</p>}
                                                            </div>
                                                        )}
                                                        <div style={{ marginTop: '10px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                                                                <div style={{ fontSize: '12px', color: '#666', fontWeight: 600 }}>🎙 Ses Kaydı</div>
                                                                {call.Durum === 'tamamlandi' && (
                                                                    <button
                                                                        onClick={() => handleVapiRefresh(call.Arama_ID)}
                                                                        disabled={vapiRefreshing[call.Arama_ID]}
                                                                        style={{ fontSize: '11px', background: 'none', border: '1px solid #ddd', borderRadius: '6px', padding: '2px 8px', cursor: 'pointer', color: '#666' }}>
                                                                        {vapiRefreshing[call.Arama_ID]
                                                                            ? <><span className="spinner-border spinner-border-sm me-1" style={{ width: '10px', height: '10px' }}></span>Yükleniyor</>
                                                                            : <><i className="feather-refresh-cw me-1" style={{ fontSize: '10px' }}></i>Yenile</>}
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {call.Kayit_URL
                                                                ? <audio controls style={{ width: '100%', borderRadius: '8px' }}>
                                                                    <source src={call.Kayit_URL} />
                                                                  </audio>
                                                                : <div style={{ fontSize: '12px', color: '#aaa', fontStyle: 'italic', padding: '8px', background: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
                                                                    Kayıt henüz hazır değil — "Yenile" butonuna basın
                                                                  </div>
                                                            }
                                                        </div>
                                                        {call.Transcript && (
                                                            <div style={{ marginTop: '10px' }}>
                                                                <div style={{ fontSize: '12px', color: '#666', marginBottom: '6px', fontWeight: 600 }}>📝 Transkript</div>
                                                                <div style={{ background: '#f8f9fa', borderRadius: '8px', padding: '12px', fontSize: '12px', color: '#333', whiteSpace: 'pre-wrap', maxHeight: '200px', overflowY: 'auto', lineHeight: 1.6 }}>
                                                                    {call.Transcript}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="addNote" ref={addNoteRef} tabIndex="-1" aria-labelledby="addNote" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Not Ekle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body p-0">
                                <div className="px-3 w-100 d-flex border-bottom align-items-center">
                                    <input className="form-control border-0 my-1 w-100 shadow-none" type="text" placeholder="Başlık" value={noteTitle} onChange={(e) => setNoteTitle(e.target.value)} />
                                </div>
                                <div className="px-3 w-100 d-flex align-items-center">
                                    <textarea className="form-control border-0 my-1 w-100 shadow-none" type="text" rows={3} placeholder="İçerik" value={noteDesc} onChange={(e) => setNoteDesc(e.target.value)}></textarea>
                                </div>
                            </div>

                            <div className="modal-footer d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div className="dropdown me-2">
                                        <a href="javascript:void(0)" onClick={createNote} className="btn btn-primary" data-bs-toggle="tooltip" data-bs-trigger="hover" title="" data-bs-original-title="Editing Actions">
                                            <span className="me-2">
                                                <i className="feather-plus"></i>
                                            </span>
                                            Ekle
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="editAciklama" ref={editAciklamaRef} tabIndex="-1" aria-labelledby="editAciklama" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Açıklama Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <textarea
                                    className="form-control"
                                    rows={4}
                                    value={yeniAciklama}
                                    onChange={(e) => setYeniAciklama(e.target.value)}
                                    placeholder="Açıklama giriniz..."
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleAciklamaUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="modal fade-scale" id="editTemsilci" ref={editTemsilciRef} tabIndex="-1" aria-labelledby="editTemsilci" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Temsilci Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <select ref={temsilciSelectRef} className="form-control form-select">
                                    {temsilciler.map((temsilci) => {
                                        return <option key={"temsilci-" + temsilci.value} value={temsilci.value} selected={formData.Temsilci_ID === temsilci.value}>{temsilci.label}</option>;
                                    })}
                                </select>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={changeTemsilci}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className="modal fade-scale" id="editReminder" ref={editReminderRef} tabIndex="-1" aria-labelledby="editReminder" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Hatırlatma Tarihi Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <input
                                    class="form-control"
                                    type="datetime-local"
                                    value={reminderDate}
                                    onChange={(e) => setReminderDate(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleReminderUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="addEtiket" ref={addEtiketRef} tabIndex="-1" aria-labelledby="addEtiket" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Etiket Ekle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <Select2WColor
                                    value={newEtiket}
                                    key={"etiket-" + formID}
                                    options={etiketler.filter(
                                        (etiket) => !formData.Etiketler.some(selected => selected.Etiket_ID === etiket.value)
                                    )}
                                    isSearchable={true}
                                    onChange={(e) => setNewEtiket(e)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={(e) => addEtiket("label")}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="modal fade-scale" id="viewNote" ref={viewNoteRef} tabIndex="-1" aria-labelledby="viewNote" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        {selectedNote && (
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h2 className="d-flex flex-column mb-0">
                                        <span className="fs-18 fw-bold mb-1">Not Ekle</span>
                                    </h2>
                                    <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                        <i className="feather-x text-danger"></i>
                                    </a>
                                </div>
                                <div className="modal-body p-0">
                                    <div className="px-3 mt-3 w-100">
                                        <label className='form-label'>Not Başlığı</label>
                                        <input className="form-control border-0 my-1 w-100 shadow-none" type="text" placeholder="Başlık" value={selectedNote.Not_Basligi} readOnly />
                                    </div>
                                    <div className="px-3 mt-3 w-100">
                                        <label className='form-label'>Not Açıklaması</label>
                                        <textarea id="viewNoteDesc" className="form-control border-0 my-1 w-100 shadow-none" type="text" placeholder="İçerik" value={selectedNote.Not_Aciklamasi} readOnly></textarea>
                                    </div>
                                </div>

                                <div className="modal-footer d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                        <a href="javascript:void(0)" className="btn btn-secondary" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="modal" title="" data-bs-original-title="Editing Actions">
                                            <span className="me-2">
                                                <i className="feather-x"></i>
                                            </span>
                                            Kapat
                                        </a>
                                        <a href="javascript:void(0)" className="btn btn-danger" onClick={(e) => deleteNote(selectedNote.Not_ID)} data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="modal" title="" data-bs-original-title="Editing Actions">
                                            <span className="me-2">
                                                <i className="feather-trash-2"></i>
                                            </span>
                                            Sil
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="modal fade-scale" id="editNameSurname" ref={editNameSurnameRef} tabIndex="-1" aria-labelledby="editNameSurname" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Adı Soyadı Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <input
                                    class="form-control"
                                    type="text"
                                    value={newNameSurname}
                                    onChange={(e) => setNewNameSurname(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleNameSurnameUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="editEmail" ref={editEmailRef} tabIndex="-1" aria-labelledby="editEmail" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">E-Posta Adresi Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <input
                                    class="form-control"
                                    type="text"
                                    value={newEmail}
                                    onChange={(e) => setNewEmail(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleEmailUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="editPhoneNumber" ref={editPhoneNumberRef} tabIndex="-1" aria-labelledby="editPhoneNumber" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Telefon Numarası Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <input
                                    class="form-control"
                                    type="text"
                                    value={newPhoneNumber}
                                    onChange={(e) => setNewPhoneNumber(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handlePhoneNumberUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade-scale" id="editVisitDate" ref={editVisitDateRef} tabIndex="-1" aria-labelledby="editVisitDate" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Tel/Mail Görüşme Zamanı Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <input
                                    className="form-control"
                                    type="datetime-local"
                                    value={visitDate}
                                    onChange={(e) => setVisitDate(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger me-auto"
                                    onClick={handleVisitDateRemove}
                                >Tarihi Kaldır</button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleVisitDateUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade-scale" id="editMeetCount" ref={editMeetCountRef} tabIndex="-1" aria-labelledby="editMeetCount" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Görüşme Sayısı Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <input
                                    className="form-control"
                                    type="number"
                                    min="0"
                                    value={meetCount}
                                    onChange={(e) => setMeetCount(Number(e.target.value))}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleMeetCountUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade-scale" id="editSellDate" ref={editSellDateRef} tabIndex="-1" aria-labelledby="editSellDate" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Satış Tarihi Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <input
                                    className="form-control"
                                    type="datetime-local"
                                    value={sellDate}
                                    onChange={(e) => setSellDate(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger me-auto"
                                    onClick={handleSellDateRemove}
                                >Tarihi Kaldır</button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSellDateUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="editBeklenenKapanisTarihi" ref={editBeklenenKapanisTarihiRef} tabIndex="-1" aria-labelledby="editBeklenenKapanisTarihi" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Beklenen Kapanış Tarihi Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <input
                                    className="form-control"
                                    type="date"
                                    min={formatToDateOnly(new Date())}
                                    value={beklenenKapanisTarihi}
                                    onChange={(e) => setBeklenenKapanisTarihi(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!beklenenKapanisTarihi || beklenenKapanisTarihi < formatToDateOnly(new Date())}
                                    onClick={handleBeklenenKapanisTarihiUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="editSonrakiAksiyonTarihi" ref={editSonrakiAksiyonTarihiRef} tabIndex="-1" aria-labelledby="editSonrakiAksiyonTarihi" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Sonraki Aksiyon Tarihi Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <input
                                    className="form-control"
                                    type="date"
                                    min={formatToDateOnly(new Date())}
                                    value={sonrakiAksiyonTarihi}
                                    onChange={(e) => setSonrakiAksiyonTarihi(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!sonrakiAksiyonTarihi || sonrakiAksiyonTarihi < formatToDateOnly(new Date())}
                                    onClick={handleSonrakiAksiyonTarihiUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Toplantı Tarihi Modal */}
                <div className="modal fade-scale" id="editToplantıTarihi" ref={editToplantıTarihiRef} tabIndex="-1" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Toplantı Yapıldı</span>
                                    <span className="fs-12 text-muted fw-normal">Toplantı tarihini giriniz</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <label className="form-label fw-semibold">Toplantı Tarihi</label>
                                <input
                                    className="form-control"
                                    type="datetime-local"
                                    value={toplantıTarihiInput}
                                    onChange={(e) => setToplantıTarihiInput(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
                                <button type="button" className="btn text-white" style={{ backgroundColor: '#6f42c1' }} onClick={handleToplantıYapıldıKaydet} disabled={isPipelineLoading}>
                                    <i className="feather-users me-1"></i>Toplantı Yapıldı İşaretle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* SMS Gönder Modal */}
                {/* Kayıp İşaretle Modal */}
                <div className="modal fade-scale" id="kayipModal" ref={kayipModalRef} tabIndex="-1" aria-labelledby="kayipModal" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Satışa Dönmedi Olarak İşaretle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <label className="form-label fw-semibold">Neden satışa dönmedi?</label>
                                <textarea
                                    className="form-control"
                                    rows={4}
                                    placeholder="Müşteri gerekçesi, bütçe sorunu vb."
                                    value={kayipNeden}
                                    onChange={(e) => setKayipNeden(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
                                <button type="button" className="btn btn-danger" onClick={handleKayipIsaretle}>
                                    <i className="feather-x-circle me-1"></i>Satışa Dönmedi İşaretle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="sendSmsModal" tabIndex="-1" aria-labelledby="sendSmsModal" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">SMS Gönder</span>
                                    <span className="fs-12 text-muted fw-normal">{formData?.LeadInfo?.Telefon}</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    maxLength={480}
                                    placeholder="SMS mesajınızı yazın..."
                                    value={smsMessage}
                                    onChange={(e) => setSmsMessage(e.target.value)}
                                />
                                <div className="text-end mt-1 text-muted" style={{ fontSize: '11px' }}>
                                    {smsMessage.length}/480 karakter
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
                                <button type="button" className="btn btn-info text-white" onClick={handleSendSms} disabled={isSendingSms}>
                                    {isSendingSms ? <><span className="spinner-border spinner-border-sm me-1"></span>Gönderiliyor...</> : <><i className="feather-send me-1"></i>Gönder</>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
            <ChatWidget ref={chatRef} quickButtons=
                {[
                    {
                        label: "Lead Analizi",
                        value: "Lead analizi yap."
                    }
                ]} handleNewUserMessage={analyzeAI} />
        </Layout>
    );
};

export default FormDetay;
